/* eslint-disable react/prop-types */
/* eslint-disable eqeqeq */
import React, { Fragment, useState } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/styles";
import {
  Card,
  Grid,
  Paper,
  TextField,
  Toolbar,
  CircularProgress,
  Backdrop,
} from "@material-ui/core";
import BottomBar from "../../../components/BottomBar/BottomBar";
import { HttpRequest } from "../../../utils/httpRequests";
import NavBar from "../../../components/NavBar/NavBar";
import CustomizedSnackbar from "../../../components/CustomizedSnackbar/CustomizedSnackbar";
import { IsEmpty } from "../../../utils/helper";
import { DatePicker } from "@material-ui/pickers";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import LoginMenu from "../../../components/LoginMenu/LoginMenu";

const useStyles = (theme) => ({
  icon: {
    marginRight: theme.spacing(1),
  },
  heroContent: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(2, 0, 2),
  },
  heroButtons: {
    marginTop: theme.spacing(4),
  },
  cardGrid: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  card: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
  },
  cardMedia: {
    paddingTop: "56.25%", // 16:9
  },
  cardContent: {
    flexGrow: 1,
  },
  cardContentDiv: {
    display: "flex",
    justifyContent: "space-between",
  },
  footer: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(6),
  },
  tabsContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    marginTop: 70,
    marginBottom: 10,
    overFlow: "hidden",
  },
  contentContainer: {
    alignItems: "center",
    textAlign: "center",
    width: "100%",
    marginLeft: 10,
    marginRight: 5,
  },
  contentContainerSM: {
    alignItems: "center",
    textAlign: "center",
    width: "65%",
    marginLeft: 10,
    marginRight: 5,
  },
  tableSubHeaderRowRow: {
    background: "#4e7cb899",
    color: "white !important",
    fontWeight: 600,
  },
  tableSubHeaderCell: {
    background: "#4e7cb899",
    color: "white !important",
    fontWeight: 200,
  },
});

// eslint-disable-next-line react/prop-types
const TextFieldInList = ({ key, id, name, label, initialPrice }) => {
  console.log("initialPrice", initialPrice);
  const [priceVal, setPriceVal] = useState(initialPrice);

  const handleChange = (id, event) => {
    const newValue = event.target.value;
    if (newValue === "" || /^\d*\.?\d*$/.test(newValue)) {
      setPriceVal(newValue); // Update local state
    }
    // onChange(id, newValue); // Call the parent component's onChange handler
  };

  return (
    <div>
      <TextField
        key={key}
        id={id}
        name={name}
        label={label}
        variant="outlined"
        value={priceVal}
        onChange={(e) => handleChange(id, e)}
        style={{ margin: "10px" }}
      />
    </div>
  );
};

class F303GeneralPricingFormV3 extends React.Component {
  constructor(props) {
    super(props);
    const ckAdminObject = localStorage.getItem("ckAdminUser") || "{}";
    const ckAdminJsonObject = JSON.parse(ckAdminObject) || {};
    const storedToken = ckAdminJsonObject.jwttoken || "";

    this.state = {
      recordId: this.props.match.params.recordId,
      priceLabel: "",
      gstPercentage: 0,
      discountCategoriesList: [],
      selectedPriceCategoriesList: [],
      discountCategoryProductList: [],
      selectedPriceCategoriesProductList: [],
      isPriceReadyToSubmit: false,
      isOpenSnackbar: false,
      snackbarMessage: "",
      snackbarSeverity: "",
      token: storedToken,
      effectiveFrom: new Date(),
      effectiveTo: this.getNextMonthDate(),
      //textFields: {}
      textFields: {}, // Initialize with some fields
      isLoading: false,
      isSubmitLoading: false,
      isLoginMenu: false,
      isReload: true,
    };
  }

  getNextMonthDate() {
    let today = new Date(); // Get today's date
    let currentYear = today.getFullYear(); // Get current year
    let currentMonth = today.getMonth(); // Get current month (0-11)
    let currentDay = today.getDate(); // Get current day of the month

    // Increment the month
    let nextMonth = new Date(currentYear, currentMonth + 1, currentDay);

    // Check if nextMonth has rolled over to another month than expected
    if (nextMonth.getMonth() !== (currentMonth + 1) % 12) {
      // Set date to the last day of the intended month
      nextMonth = new Date(currentYear, currentMonth + 1, 0);
    }

    return nextMonth;
  }

  getTomorrowDate = () => {
    let a = new Date();
    a.setDate(a.getDate() + 1);
    return a;
  };
  componentDidMount() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    // this.getPriceCategoriesData();
    const id = this.props.match.params.recordId;
    if (id != 0) {
      this.setState({
        recordId: id,
      });
      this.getPriceCategoriesData(id);
      // this.getData();
    } else {
      this.getPriceCategoriesData(0);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.match.params.recordId != nextProps.match.params.recordId) {
      if (nextProps.match.params.recordId != 0) {
        this.getData(nextProps.match.params.recordId);
      } else {
        window.location.reload();
      }
    }
  }

  // handleOnChange = (e) => {
  //   this.setState(prevState => ({
  //     discountCategoryProductList: prevState.discountCategoryProductList.map(item =>
  //       item.id === id ? { ...item, price: newValue } : item
  //     ),
  //   }));
  // };

  handleSnackbar = (isOpen, message, severity) => {
    this.setState({
      isOpenSnackbar: isOpen,
      snackbarMessage: message,
      snackbarSeverity: severity,
    });
  };

  //Added By Farhan
  getData = async (index) => {
    const data = new FormData();

    data.append("", index);
    const res = await HttpRequest(
      "GET",
      `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/C303CommonProductsViewV2?&recordId=${index}`,
      null,
      "authorizeJson"
    );
    if (res.isSuccess) {
      if (res.data != null && res.data.length > 0) {
        let vouchersData = res.data[0];

        let dateFrom = vouchersData.effectiveFrom;
        let dateTo = vouchersData.effectiveTo;

        // this.getPriceCategoriesProductData(vouchersData.categoryId);
        this.setState({
          Data: res.data || [],
          priceLabel: vouchersData.priceLabel,
          gstPercentage: vouchersData.gstPercentage,
          selectedPriceCategoriesProductList: vouchersData.isSelectedAll
            ? []
            : vouchersData.productId,

          // selectAllCategoryProducts: vouchersData.isSelectedAll,
          effectiveFrom: dateFrom,
          effectiveTo: dateTo,

          selectedPriceCategoriesList: vouchersData.categoryId,
          // selectStoreWideCategories: vouchersData.isStoreWide,
          // notification: vouchersData.notificationMsg,
        });
      }
    }

    // this.setState({
    //     isLoading: false,
    // });
  };

  setPriceCategoryV2 = async (e) => {
    console.log(e);
    this.state.selectedPriceCategoriesList = [];
    await this.setState({
      selectedPriceCategoriesList: e,
    });
    this.getPriceCategoriesProductData(e);
  };

  getPriceCategoriesData = async () => {
    this.setState({
      isLoading: true,
    });
    const data = new FormData();
    data.append("recordId", this.state.recordId);
    const res = await HttpRequest(
      "Post",
      `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/C303CommonProductsViewV2`,
      data,
      "authorize"
    );
    if (res.isSuccess) {
      console.log("discount categories response", res.data);
      if (res.data != null && res.data.length > 0) {
        if (this.state.recordId == 0) {
          this.setState({
            discountCategoriesList: res.data,
          });
        } else {
          this.setState({
            discountCategoriesList: res.data,
            priceLabel: res.data[0].priceListLabel,
            gstPercentage: res.data[0].gstPercentage,
            effectiveFrom: res.data[0].fromDate,
            effectiveTo: res.data[0].toDate,
          });
        }
      }
    } else {
      if (res.statusCode === 401) {
        this.setState({
          isLoginMenu: true,
        });
      } else {
        this.handleSnackbar(true, res.message, "error");
      }
    }
    this.setState({
      isLoading: false,
    });
  };

  getPriceCategoriesProductData = async (selectedPriceCategoriesList) => {
    if (selectedPriceCategoriesList.length > 0) {
      const data = new FormData();
      for (let i = 0; i < selectedPriceCategoriesList.length; i++) {
        data.append("categoryId", selectedPriceCategoriesList[i].id);
      }
      data.append("recordId", this.state.recordId);
      const res = await HttpRequest(
        "POST",
        `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/C303CommonProductsViewV2`,
        data,
        "authorize"
      );
      if (res.isSuccess) {
        console.log("discount products response", res);
        if (res.data != null && res.data.length > 0) {
          this.setState({
            discountCategoryProductList: res.data,
          });
        }
      }
    } else {
      this.setState({
        discountCategoryProductList: [],
      });
    }
  };

  handleTextFieldChange = (
    categoryIndex,
    attributeIndex,
    sizeIndex,
    field,
    value
  ) => {
    if (/^\d*\.?\d*$/.test(value)) {
      // Regular expression to allow only numeric values and one decimal point
      this.setState((prevState) => {
        const newTextFields = { ...prevState.textFields };

        if (!newTextFields[categoryIndex]) {
          newTextFields[categoryIndex] = {};
        }
        if (!newTextFields[categoryIndex][attributeIndex]) {
          newTextFields[categoryIndex][attributeIndex] = {};
        }
        if (!newTextFields[categoryIndex][attributeIndex][sizeIndex]) {
          newTextFields[categoryIndex][attributeIndex][sizeIndex] = {};
        }

        newTextFields[categoryIndex][attributeIndex][sizeIndex][field] = value;

        return { textFields: newTextFields };
      });
    }
  };

  submitPrice = async () => {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    // Initialize an empty object to hold the JSON structure
    const jsonPayload = {};

    const priceLabel = this.state.priceLabel;
    const gstPercentage = this.state.gstPercentage;

    if (IsEmpty(priceLabel)) {
      this.handleSnackbar(true, "Please add price label.", "error");
      return false;
    }


    if (gstPercentage <= 0) {
      this.handleSnackbar(true, "Please add gst Percentage.", "error");
      return false;
    }

    const effectiveFrom = document.getElementById("effectiveFrom").value;
    const effectiveTo = document.getElementById("effectiveTo").value;

    for (let i = 0; i < document.getElementsByName("categoryId").length; i++) {
      let categoryId = document.getElementsByName("categoryId")[i].value;
      //Ensure the categoryId exists in the payload
      if (!jsonPayload[categoryId]) {
        jsonPayload[categoryId] = {
          categoryId: categoryId,
          recordId: this.state.recordId,
          priceLabel: priceLabel,
          gstPercentage: gstPercentage,
          fromDate: effectiveFrom,
          toDate: effectiveTo,
          sizes: [],
          bundles: [],
          styles: [],
          pages: [],
          covers: [],
          lamination: [],
          packaging: [],
        };
      }

      let categorySizesArray = document.getElementsByName(
        categoryId + ":sizeId"
      );

      for (let j = 0; j < categorySizesArray.length; j++) {
        let sizeId = categorySizesArray[j].value;
        let sizePrice = document.getElementById(
          categoryId + "_" + sizeId + "_size"
        ).value;
        let sizeobject = { sizeId: sizeId, sizePrice: sizePrice };
        jsonPayload[categoryId].sizes.push(sizeobject);
      }

      // if(categoryId == 5){
      //   //debugger;
      //   let categoryBundleArray=document.getElementsByName(categoryId+":bundleId");
      //
      //   for(let j=0;j<categoryBundleArray.length;j++){
      //     let productId=categoryBundleArray[j].value;
      //     let productPrice=document.getElementById(productId+"_product").value;
      //     let bundleObject={ "productId": productId,"productPrice":productPrice};
      //     jsonPayload[categoryId].bundles.push(bundleObject);
      //   }
      // }else{
      //   //debugger;
      //   let categoryBundleArray=document.getElementsByName(categoryId+":bundleId");
      //
      //   for(let j=0;j<categoryBundleArray.length;j++){
      //     let bundleId=categoryBundleArray[j].value;
      //     let bundlePrice=document.getElementById(categoryId+"_"+bundleId+"_bundle").value;;
      //     let bundleObject={ "bundleId": bundleId,"bundlePrice":bundlePrice};
      //     jsonPayload[categoryId].bundles.push(bundleObject);
      //   }
      // }

      let categoryBundleArray = document.getElementsByName(
        categoryId + ":bundleId"
      );

      for (let j = 0; j < categoryBundleArray.length; j++) {
        let productId = categoryBundleArray[j].value;
        let productPrice = document.getElementById(
          productId + "_product"
        ).value;
        let bundleObject = { productId: productId, productPrice: productPrice };
        jsonPayload[categoryId].bundles.push(bundleObject);
      }

      let categorypageTypesArray = document.getElementsByName(
        categoryId + ":productStyleId"
      );
      for (let j = 0; j < categorypageTypesArray.length; j++) {
        let productId = categorypageTypesArray[j].value;
        let price = document.getElementById(productId + "_product").value;
        let object = { productId: productId, productPrice: price };
        jsonPayload[categoryId].styles.push(object);
      }
      let categoryPageNumbersArray = document.getElementsByName(
        categoryId + ":pageNumberId"
      );
      for (let j = 0; j < categoryPageNumbersArray.length; j++) {
        let productId = categoryPageNumbersArray[j].value;
        let price = document.getElementById(productId + "_product").value;
        let object = { productId: productId, productPrice: price };
        jsonPayload[categoryId].pages.push(object);
      }

      // for(let j=0;j<categorypageTypesArray.length;j++){
      //   let id=categorypageTypesArray[j].value;
      //   let price=document.getElementById(categoryId+"_"+id+"_pageType").value;
      //
      //   let categorypageTypesNumbersArray=document.getElementsByName(categoryId+"_"+id+":pageNumber");
      //
      //   let pagesList=[];
      //   for(let k=0;k<categorypageTypesNumbersArray.length;k++){
      //     let pageListid=categorypageTypesNumbersArray[k].value;
      //     let price=document.getElementById(categoryId+"_"+pageListid+"_"+id+"_pages").value;
      //
      //     let pageObject={ "pageNumber": pageListid,"pageNumberPrice":price};
      //     pagesList.push(pageObject);
      //
      //   }
      //   let object={ "pageTypeId": id,"pageTypePrice":price,"pages":pagesList};
      //   jsonPayload[categoryId].pages.push(object);
      //
      // }

      let categoryCoverArray = document.getElementsByName(
        categoryId + ":coverId"
      );

      for (let j = 0; j < categoryCoverArray.length; j++) {
        let productId = categoryCoverArray[j].value;
        let price = document.getElementById(productId + "_product").value;
        let object = { productId: productId, productPrice: price };
        jsonPayload[categoryId].covers.push(object);
      }

      // let categoryPackagingArray=document.getElementsByName(categoryId+":packagingId");
      //
      // for(let j=0;j<categoryPackagingArray.length;j++){
      //   let id=categoryPackagingArray[j].value;
      //   let price=document.getElementById(categoryId+"_"+id+"_packaging").value;;
      //   let object={ "packagingId": id,"packagingPrice":price};
      //   jsonPayload[categoryId].packaging.push(object);
      // }

      let categoryPackagingArray = document.getElementsByName(
        categoryId + ":packagingId"
      );

      for (let j = 0; j < categoryPackagingArray.length; j++) {
        let productId = categoryPackagingArray[j].value;
        let productPrice = document.getElementById(
          productId + "_product"
        ).value;
        let object = { productId: productId, productPrice: productPrice };
        jsonPayload[categoryId].packaging.push(object);
      }

      let categoryLaminationArray = document.getElementsByName(
        categoryId + ":laminationId"
      );

      for (let j = 0; j < categoryLaminationArray.length; j++) {
        let productId = categoryLaminationArray[j].value;
        let price = document.getElementById(productId + "_product").value;
        let object = { productId: productId, productPrice: price };
        jsonPayload[categoryId].lamination.push(object);
      }
    }

    // Convert the jsonPayload to JSON string
    const jsonString = JSON.stringify(Object.values(jsonPayload));
    this.setState({
      isSubmitLoading: true,
    });
    // Send the JSON payload
    const res = await HttpRequest(
      "POST",
      `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/C303CommonProductsPricesSave`,
      jsonString,
      "authorizeJson"
    );

    if (res.isSuccess) {
      this.handleSnackbar(true, "Saved", "success");
      window.location.reload();
    } else {
      if (res.statusCode === 401) {
        this.setState({
          isLoginMenu: true,
          isReload: false,
        });
      } else {
        this.handleSnackbar(true, res.message, "error");
      }
    }

    this.setState({
      isSubmitLoading: false,
    });
  };



  setEffectiveFrom = (date) => {
    this.setState({
      effectiveFrom: date,
    });
  };

  setEffectiveTo = (date) => {
    this.setState({
      effectiveTo: date,
    });
  };

  viewReport = async () => {
    window.location = "#/F303GeneralPricingReport";
  };

  handleTextFieldChange = (fieldId, value) => {
    this.setState((prevState) => ({
      textFields: {
        ...prevState.textFields,
        [fieldId]: value,
      },
    }));
  };

  initializeTextFields = (categories) => {
    const textFields = {};
    categories.forEach((category) => {
      category.productAttributes[0].sizes.forEach((size) => {
        textFields[`${category.categoryId}_${size.id}`] = "";
      });
    });
    this.setState({ textFields });
  };

  renderDynamicTextFields = () => {
    const { textFields } = this.state;
    return Object.keys(textFields).map((fieldId) => (
      <TextField
        key={fieldId}
        id={`textfield-${fieldId}`}
        label={`Field ${fieldId}`}
        variant="outlined"
        value={textFields[fieldId]}
        onChange={(e) => this.handleTextFieldChange(fieldId, e.target.value)}
        style={{ margin: "10px" }}
      />
    ));
  };

  render() {
    const { classes } = this.props;
    let { discountCategoriesList } = this.state;
    let screenHeight = window.screen.height;

    return (
      <Fragment>
        <LoginMenu
          reload={this.state.isReload}
          open={this.state.isLoginMenu}
          handleClose={() => this.setState({ isLoginMenu: false })}
        />
        <Grid
          container
          xs={12}
          direction={"column"}
          justifyContent="center"
          alignItems="center"
          style={{ padding: 10 }}
        >
          <Toolbar>
            <NavBar isAuthorize title="General Pricing" />
            {/* <LoginMenu
                    reload={this.state.isReload}
                    open={this.state.isLoginMenu}
                    handleClose={() => this.setState({ isLoginMenu: false })}
                    /> */}
          </Toolbar>
          <Card
            style={{
              width: "98%",
              height: "auto",
              paddingTop: 20,
              paddingBottom: 100,
              paddingLeft: 20,
              paddingRight: 20,
            }}
          >
            <form id="myForm" style={{ minHeight: screenHeight }}>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "flex-start",
                  marginBottom: "20px",
                }}
              >
                <Grid container spacing={2} alignItems={"flex-start"}>
                  <Grid item xs={6}>
                    <TextField
                      id="discount-label"
                      value={this.state.priceLabel}
                      fullWidth
                      label="Price Label"
                      variant="outlined"
                      onChange={(val) => {
                        this.setState({
                          priceLabel: val.target.value,
                        });
                      }}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      id="gst-percentage"
                      type="number"
                      value={this.state.gstPercentage}
                      fullWidth
                      label="Gst %"
                      variant="outlined"
                      onFocus={() => {
                        if (this.state.gstPercentage === '0' || this.state.gstPercentage === 0) {
                          this.setState({ gstPercentage: '' });
                        }
                      }}
                      onChange={(val) => {
                        this.setState({
                          gstPercentage: val.target.value,
                        });
                      }}
                    />
                  </Grid>
                </Grid>
              </div>

              <Grid container spacing={2} alignItems={"flex-start"}>
                <Grid container item xs={6}>
                  <DatePicker
                    format="dd-MM-yyyy"
                    autoOk
                    label="Effective from"
                    id="effectiveFrom"
                    value={this.state.effectiveFrom}
                    onChange={this.setEffectiveFrom}
                    required
                    fullWidth
                    inputVariant="outlined"
                  />
                </Grid>
                <Grid container item xs={6}>
                  <DatePicker
                    format="dd-MM-yyyy"
                    autoOk
                    label="Effective To"
                    id="effectiveTo"
                    value={this.state.effectiveTo}
                    onChange={this.setEffectiveTo}
                    required
                    fullWidth
                    inputVariant="outlined"
                  />
                </Grid>
              </Grid>
              {this.state.isLoading ? (
                <div
                  style={{
                    marginTop: 50,
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <CircularProgress
                    size={50}
                    style={{
                      color: "rgb(29, 95, 152)",
                      fontWeight: 600,
                    }}
                  />
                </div>
              ) : (
                <div style={{ width: "100%", marginBottom: 20, marginTop: 20 }}>
                  <TableContainer component={Paper}>
                    {discountCategoriesList.map((row) => (
                      <Table key={row} aria-label="simple table">
                        <TableHead>
                          <TableRow>
                            <TableCell
                              align="left"
                              style={{
                                background: "rgb(250 178 70)",
                                color: "white",
                              }}
                            >
                              {row.categoryLabel}
                              <input
                                name={"categoryId"}
                                value={row.categoryId}
                                type="hidden"
                              />
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {/* Sizes Started */}
                          {/*  Sizes field will be utilized by All Products*/}
                          <TableRow>
                            <TableCell>
                              <Table
                                style={{
                                  border: "1px solid rgb(224 224 224)",
                                  borderBottom: "1px solid rgb(224 224 224)",
                                }}
                                aria-label="simple table"
                              >
                                <TableHead>
                                  <TableRow
                                    className={classes.tableSubHeaderRow}
                                  >
                                    <TableCell
                                      align="left"
                                      className={classes.tableSubHeaderCell}
                                    >
                                      Sizes{" "}
                                    </TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  <TableRow>
                                    <TableCell align="left">
                                      <Table
                                        style={{
                                          border: "1px solid rgb(224 224 224)",
                                        }}
                                        aria-label="simple table"
                                      >
                                        <TableHead>
                                          <TableRow>
                                            {row.productAttributes[0].sizes.map(
                                              (size) => (
                                                <TableCell
                                                  key={size}
                                                  align="left"
                                                >
                                                  {size.userLabel}{" "}
                                                </TableCell>
                                              )
                                            )}
                                          </TableRow>
                                        </TableHead>
                                        <TableBody>
                                          <TableRow>
                                            {row.productAttributes[0].sizes.map(
                                              (size, sizeIndex) => (
                                                <TableCell
                                                  align="left"
                                                  key={sizeIndex}
                                                >
                                                  <>
                                                    <input
                                                      type="hidden"
                                                      name={`${row.categoryId}:sizeId`}
                                                      value={size.id}
                                                    />

                                                    <TextFieldInList
                                                      key={
                                                        sizeIndex +
                                                        row.categoryId
                                                      }
                                                      id={`${row.categoryId}_${size.id}_size`}
                                                      name={`${row.categoryId}_${size.id}_size`}
                                                      label="price"
                                                      initialPrice={size.price}
                                                    />

                                                    {/*
                                                      <TextField
                                                          name={`${row.categoryId}_${size.id}_size`}
                                                          variant="outlined"
                                                          id={`${row.categoryId}_${size.id}_size`}
                                                          size="small"
                                                          type="text"
                                                          value={size.price}
                                                          // value={(textFields[categoryIndex] &&
                                                          //         textFields[categoryIndex][0] &&
                                                          //         textFields[categoryIndex][0][packagingIndex] &&
                                                          //         textFields[categoryIndex][0][packagingIndex].packaging) || ''}
                                                      onChange={(e) =>
                                                        this.handleTextFieldChange(categoryIndex, 0, sizeIndex, 'size', e.target.value)
                                                      }
                                                     />  */}
                                                  </>
                                                </TableCell>
                                              )
                                            )}
                                          </TableRow>
                                        </TableBody>
                                      </Table>
                                    </TableCell>
                                  </TableRow>
                                </TableBody>
                              </Table>
                            </TableCell>
                          </TableRow>
                          {/* Sizes Ended */}

                          {/*Page Styles Fields Start*/}
                          {/*Page Styles Field For Custom Photobook*/}
                          {row.categoryId == 1 ? (
                            <>
                              {/* Pages Types Started */}
                              <TableRow>
                                <TableCell>
                                  <Table
                                    style={{
                                      border: "1px solid rgb(224 224 224)",
                                      borderBottom:
                                        "1px solid rgb(224 224 224)",
                                    }}
                                    aria-label="simple table"
                                  >
                                    <TableHead>
                                      <TableRow
                                        className={classes.tableSubHeaderRow}
                                      >
                                        <TableCell
                                          className={classes.tableSubHeaderCell}
                                          align="left"
                                        >
                                          {"Page Styles"}{" "}
                                        </TableCell>
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      <TableRow>
                                        <TableCell align="left">
                                          <Table
                                            style={{
                                              border:
                                                "1px solid rgb(224 224 224)",
                                            }}
                                            aria-label="simple table"
                                          >
                                            {row.productAttributes[0].styles.map(
                                              (styles, pageTypesIndex) => {
                                                return (
                                                  <>
                                                    {pageTypesIndex % 4 ===
                                                      0 ? (
                                                      <>
                                                        <TableHead>
                                                          <TableRow>
                                                            <TableCell align="left">
                                                              {
                                                                row
                                                                  .productAttributes[0]
                                                                  .styles[
                                                                  pageTypesIndex
                                                                ].userLabel
                                                              }{" "}
                                                            </TableCell>
                                                            {pageTypesIndex +
                                                              1 <
                                                              row
                                                                .productAttributes[0]
                                                                .styles.length ? (
                                                              <TableCell align="left">
                                                                {
                                                                  row
                                                                    .productAttributes[0]
                                                                    .styles[
                                                                    pageTypesIndex +
                                                                    1
                                                                  ].userLabel
                                                                }{" "}
                                                              </TableCell>
                                                            ) : (
                                                              <span />
                                                            )}

                                                            {pageTypesIndex +
                                                              2 <
                                                              row
                                                                .productAttributes[0]
                                                                .styles.length ? (
                                                              <TableCell align="left">
                                                                {
                                                                  row
                                                                    .productAttributes[0]
                                                                    .styles[
                                                                    pageTypesIndex +
                                                                    2
                                                                  ].userLabel
                                                                }{" "}
                                                              </TableCell>
                                                            ) : (
                                                              <span />
                                                            )}
                                                            {pageTypesIndex +
                                                              3 <
                                                              row
                                                                .productAttributes[0]
                                                                .styles.length ? (
                                                              <TableCell align="left">
                                                                {
                                                                  row
                                                                    .productAttributes[0]
                                                                    .styles[
                                                                    pageTypesIndex +
                                                                    3
                                                                  ].userLabel
                                                                }{" "}
                                                              </TableCell>
                                                            ) : (
                                                              <span />
                                                            )}
                                                          </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                          <TableRow>
                                                            <TableCell align="left">
                                                              <input
                                                                type="hidden"
                                                                name={`${row.categoryId}:productStyleId`}
                                                                value={
                                                                  styles.productId
                                                                }
                                                              />
                                                              <TextFieldInList
                                                                key={
                                                                  pageTypesIndex +
                                                                  row.categoryId
                                                                }
                                                                id={`${styles.productId}_product`}
                                                                name={`${styles.productId}_product`}
                                                                label="price"
                                                                initialPrice={
                                                                  styles.price
                                                                }
                                                              />
                                                            </TableCell>
                                                            {pageTypesIndex +
                                                              1 <
                                                              row
                                                                .productAttributes[0]
                                                                .styles.length ? (
                                                              <TableCell align="left">
                                                                <input
                                                                  type="hidden"
                                                                  name={`${row.categoryId}:productStyleId`}
                                                                  value={
                                                                    row
                                                                      .productAttributes[0]
                                                                      .styles[
                                                                      pageTypesIndex +
                                                                      1
                                                                    ].productId
                                                                  }
                                                                />
                                                                <TextFieldInList
                                                                  key={
                                                                    pageTypesIndex +
                                                                    1 +
                                                                    row.categoryId
                                                                  }
                                                                  id={`${row
                                                                    .productAttributes[0]
                                                                    .styles[
                                                                    pageTypesIndex +
                                                                    1
                                                                  ].productId
                                                                    }_product`}
                                                                  name={`${row
                                                                    .productAttributes[0]
                                                                    .styles[
                                                                    pageTypesIndex +
                                                                    1
                                                                  ].productId
                                                                    }_product`}
                                                                  label="price"
                                                                  initialPrice={
                                                                    row
                                                                      .productAttributes[0]
                                                                      .styles[
                                                                      pageTypesIndex +
                                                                      1
                                                                    ].price
                                                                  }
                                                                />
                                                              </TableCell>
                                                            ) : (
                                                              <span />
                                                            )}

                                                            {pageTypesIndex +
                                                              2 <
                                                              row
                                                                .productAttributes[0]
                                                                .styles.length ? (
                                                              <TableCell align="left">
                                                                <input
                                                                  type="hidden"
                                                                  name={`${row.categoryId}:productStyleId`}
                                                                  value={
                                                                    row
                                                                      .productAttributes[0]
                                                                      .styles[
                                                                      pageTypesIndex +
                                                                      2
                                                                    ].productId
                                                                  }
                                                                />
                                                                <TextFieldInList
                                                                  key={
                                                                    pageTypesIndex +
                                                                    2 +
                                                                    row.categoryId
                                                                  }
                                                                  id={`${row
                                                                    .productAttributes[0]
                                                                    .styles[
                                                                    pageTypesIndex +
                                                                    2
                                                                  ].productId
                                                                    }_product`}
                                                                  name={`${row
                                                                    .productAttributes[0]
                                                                    .styles[
                                                                    pageTypesIndex +
                                                                    2
                                                                  ].productId
                                                                    }_product`}
                                                                  label="price"
                                                                  initialPrice={
                                                                    row
                                                                      .productAttributes[0]
                                                                      .styles[
                                                                      pageTypesIndex +
                                                                      2
                                                                    ].price
                                                                  }
                                                                />
                                                              </TableCell>
                                                            ) : (
                                                              <span />
                                                            )}
                                                            {pageTypesIndex +
                                                              3 <
                                                              row
                                                                .productAttributes[0]
                                                                .styles.length ? (
                                                              <TableCell align="left">
                                                                <input
                                                                  type="hidden"
                                                                  name={`${row.categoryId}:productStyleId`}
                                                                  value={
                                                                    row
                                                                      .productAttributes[0]
                                                                      .styles[
                                                                      pageTypesIndex +
                                                                      3
                                                                    ].productId
                                                                  }
                                                                />
                                                                <TextFieldInList
                                                                  key={
                                                                    pageTypesIndex +
                                                                    3 +
                                                                    row.categoryId
                                                                  }
                                                                  id={`${row
                                                                    .productAttributes[0]
                                                                    .styles[
                                                                    pageTypesIndex +
                                                                    3
                                                                  ].productId
                                                                    }_product`}
                                                                  name={`${row
                                                                    .productAttributes[0]
                                                                    .styles[
                                                                    pageTypesIndex +
                                                                    3
                                                                  ].productId
                                                                    }_product`}
                                                                  label="price"
                                                                  initialPrice={
                                                                    row
                                                                      .productAttributes[0]
                                                                      .styles[
                                                                      pageTypesIndex +
                                                                      3
                                                                    ].price
                                                                  }
                                                                />
                                                              </TableCell>
                                                            ) : (
                                                              <span />
                                                            )}
                                                          </TableRow>
                                                        </TableBody>
                                                      </>
                                                    ) : (
                                                      <span />
                                                    )}
                                                  </>
                                                );
                                              }
                                            )}
                                          </Table>
                                        </TableCell>
                                      </TableRow>

                                      <TableRow>
                                        <TableCell>
                                          <Table
                                            style={{
                                              border:
                                                "1px solid rgb(224 224 224)",
                                              borderBottom:
                                                "1px solid rgb(224 224 224)",
                                            }}
                                            aria-label="simple table"
                                          >
                                            <TableHead>
                                              <TableRow
                                                className={
                                                  classes.tableSubHeaderRow
                                                }
                                              >
                                                <TableCell
                                                  className={
                                                    classes.tableSubHeaderCell
                                                  }
                                                  align="left"
                                                >
                                                  {"Number of Pages"}{" "}
                                                </TableCell>
                                              </TableRow>
                                            </TableHead>
                                            <TableBody>
                                              <TableRow>
                                                <TableCell align="left">
                                                  <Table
                                                    style={{
                                                      border:
                                                        "1px solid rgb(224 224 224)",
                                                    }}
                                                    aria-label="simple table"
                                                  >
                                                    {row.productAttributes[0].pages.map(
                                                      (page, noOfPageIndex) => {
                                                        return (
                                                          <>
                                                            {noOfPageIndex %
                                                              4 ===
                                                              0 ? (
                                                              <>
                                                                <TableHead>
                                                                  <TableRow>
                                                                    <TableCell align="left">
                                                                      {
                                                                        row
                                                                          .productAttributes[0]
                                                                          .pages[
                                                                          noOfPageIndex
                                                                        ]
                                                                          .userLabel
                                                                      }{" "}
                                                                    </TableCell>
                                                                    {noOfPageIndex +
                                                                      1 <
                                                                      row
                                                                        .productAttributes[0]
                                                                        .pages
                                                                        .length ? (
                                                                      <TableCell align="left">
                                                                        {
                                                                          row
                                                                            .productAttributes[0]
                                                                            .pages[
                                                                            noOfPageIndex +
                                                                            1
                                                                          ]
                                                                            .userLabel
                                                                        }{" "}
                                                                      </TableCell>
                                                                    ) : (
                                                                      <span />
                                                                    )}

                                                                    {noOfPageIndex +
                                                                      2 <
                                                                      row
                                                                        .productAttributes[0]
                                                                        .pages
                                                                        .length ? (
                                                                      <TableCell align="left">
                                                                        {
                                                                          row
                                                                            .productAttributes[0]
                                                                            .pages[
                                                                            noOfPageIndex +
                                                                            2
                                                                          ]
                                                                            .userLabel
                                                                        }{" "}
                                                                      </TableCell>
                                                                    ) : (
                                                                      <span />
                                                                    )}
                                                                    {noOfPageIndex +
                                                                      3 <
                                                                      row
                                                                        .productAttributes[0]
                                                                        .pages
                                                                        .length ? (
                                                                      <TableCell align="left">
                                                                        {
                                                                          row
                                                                            .productAttributes[0]
                                                                            .pages[
                                                                            noOfPageIndex +
                                                                            3
                                                                          ]
                                                                            .userLabel
                                                                        }{" "}
                                                                      </TableCell>
                                                                    ) : (
                                                                      <span />
                                                                    )}
                                                                  </TableRow>
                                                                </TableHead>
                                                                <TableBody>
                                                                  <TableRow>
                                                                    <TableCell align="left">
                                                                      <input
                                                                        type="hidden"
                                                                        name={`${row.categoryId}:pageNumberId`}
                                                                        value={
                                                                          page.productId
                                                                        }
                                                                      />
                                                                      <TextFieldInList
                                                                        key={
                                                                          noOfPageIndex +
                                                                          row.categoryId
                                                                        }
                                                                        id={`${page.productId}_product`}
                                                                        name={`${page.productId}_product`}
                                                                        label="price"
                                                                        initialPrice={
                                                                          page.price
                                                                        }
                                                                      />
                                                                    </TableCell>
                                                                    {noOfPageIndex +
                                                                      1 <
                                                                      row
                                                                        .productAttributes[0]
                                                                        .pages
                                                                        .length ? (
                                                                      <TableCell align="left">
                                                                        <input
                                                                          type="hidden"
                                                                          name={`${row.categoryId}:pageNumberId`}
                                                                          value={
                                                                            row
                                                                              .productAttributes[0]
                                                                              .pages[
                                                                              noOfPageIndex +
                                                                              1
                                                                            ]
                                                                              .productId
                                                                          }
                                                                        />
                                                                        <TextFieldInList
                                                                          key={
                                                                            noOfPageIndex +
                                                                            1 +
                                                                            row.categoryId
                                                                          }
                                                                          id={`${row
                                                                            .productAttributes[0]
                                                                            .pages[
                                                                            noOfPageIndex +
                                                                            1
                                                                          ]
                                                                            .productId
                                                                            }_product`}
                                                                          name={`${row
                                                                            .productAttributes[0]
                                                                            .pages[
                                                                            noOfPageIndex +
                                                                            1
                                                                          ]
                                                                            .productId
                                                                            }_product`}
                                                                          label="price"
                                                                          initialPrice={
                                                                            row
                                                                              .productAttributes[0]
                                                                              .pages[
                                                                              noOfPageIndex +
                                                                              1
                                                                            ]
                                                                              .price
                                                                          }
                                                                        />
                                                                      </TableCell>
                                                                    ) : (
                                                                      <span />
                                                                    )}

                                                                    {noOfPageIndex +
                                                                      2 <
                                                                      row
                                                                        .productAttributes[0]
                                                                        .pages
                                                                        .length ? (
                                                                      <TableCell align="left">
                                                                        <input
                                                                          type="hidden"
                                                                          name={`${row.categoryId}:pageNumberId`}
                                                                          value={
                                                                            row
                                                                              .productAttributes[0]
                                                                              .pages[
                                                                              noOfPageIndex +
                                                                              2
                                                                            ]
                                                                              .productId
                                                                          }
                                                                        />
                                                                        <TextFieldInList
                                                                          key={
                                                                            noOfPageIndex +
                                                                            2 +
                                                                            row.categoryId
                                                                          }
                                                                          id={`${row
                                                                            .productAttributes[0]
                                                                            .pages[
                                                                            noOfPageIndex +
                                                                            2
                                                                          ]
                                                                            .productId
                                                                            }_product`}
                                                                          name={`${row
                                                                            .productAttributes[0]
                                                                            .pages[
                                                                            noOfPageIndex +
                                                                            2
                                                                          ]
                                                                            .productId
                                                                            }_product`}
                                                                          label="price"
                                                                          initialPrice={
                                                                            row
                                                                              .productAttributes[0]
                                                                              .pages[
                                                                              noOfPageIndex +
                                                                              2
                                                                            ]
                                                                              .price
                                                                          }
                                                                        />
                                                                      </TableCell>
                                                                    ) : (
                                                                      <span />
                                                                    )}
                                                                    {noOfPageIndex +
                                                                      3 <
                                                                      row
                                                                        .productAttributes[0]
                                                                        .pages
                                                                        .length ? (
                                                                      <TableCell align="left">
                                                                        <input
                                                                          type="hidden"
                                                                          name={`${row.categoryId}:pageNumberId`}
                                                                          value={
                                                                            row
                                                                              .productAttributes[0]
                                                                              .pages[
                                                                              noOfPageIndex +
                                                                              3
                                                                            ]
                                                                              .productId
                                                                          }
                                                                        />
                                                                        <TextFieldInList
                                                                          key={
                                                                            noOfPageIndex +
                                                                            3 +
                                                                            row.categoryId
                                                                          }
                                                                          id={`${row
                                                                            .productAttributes[0]
                                                                            .pages[
                                                                            noOfPageIndex +
                                                                            3
                                                                          ]
                                                                            .productId
                                                                            }_product`}
                                                                          name={`${row
                                                                            .productAttributes[0]
                                                                            .pages[
                                                                            noOfPageIndex +
                                                                            3
                                                                          ]
                                                                            .productId
                                                                            }_product`}
                                                                          label="price"
                                                                          initialPrice={
                                                                            row
                                                                              .productAttributes[0]
                                                                              .pages[
                                                                              noOfPageIndex +
                                                                              3
                                                                            ]
                                                                              .price
                                                                          }
                                                                        />
                                                                      </TableCell>
                                                                    ) : (
                                                                      <span />
                                                                    )}
                                                                  </TableRow>
                                                                </TableBody>
                                                              </>
                                                            ) : (
                                                              <span />
                                                            )}
                                                          </>
                                                        );
                                                      }
                                                    )}
                                                  </Table>
                                                </TableCell>
                                              </TableRow>
                                              {/*<TableRow>*/}
                                              {/*  <TableCell align="left">*/}
                                              {/*    <Table style={{border: "1px solid rgb(224 224 224)"}}*/}
                                              {/*           aria-label="simple table">*/}
                                              {/*      <TableHead>*/}
                                              {/*        <TableRow>*/}
                                              {/*          {row.productAttributes[0].pageTypes.map((page) => (*/}

                                              {/*              page.pages.map((pageNumber) => (*/}
                                              {/*                  <TableCell align="left">*/}

                                              {/*                    {pageNumber.userLabel + "(" + page.userLabel + ")"} </TableCell>*/}

                                              {/*              ))*/}

                                              {/*          ))}*/}
                                              {/*        </TableRow>*/}

                                              {/*      </TableHead>*/}
                                              {/*      <TableBody>*/}
                                              {/*        <TableRow>*/}
                                              {/*          {row.productAttributes[0].pageTypes.map((pageType) => {*/}
                                              {/*            const pageTypeId = pageType.id;*/}
                                              {/*            return pageType.pages.map((pageNumber, pagesIndex) => (*/}
                                              {/*                <TableCell align="left">*/}
                                              {/*                  <input type="hidden"*/}
                                              {/*                         name={`${row.categoryId}_${pageTypeId}:pageNumber`}*/}
                                              {/*                         value={pageNumber.id}/>*/}
                                              {/*                  /!* <input type="hidden" id={`${row.categoryId}_${pageNumber.id}_pages`} value={10.0+1}/> *!/*/}

                                              {/*                  <TextFieldInList*/}
                                              {/*                      key={pagesIndex + row.categoryId}*/}
                                              {/*                      id={`${row.categoryId}_${pageNumber.id}_${pageTypeId}_pages`}*/}
                                              {/*                      name={`${row.categoryId}_${pageNumber.id}_${pageTypeId}_pages`}*/}
                                              {/*                      label="price"*/}
                                              {/*                      initialPrice={pageNumber.price}*/}
                                              {/*                  />*/}

                                              {/*                  /!* <TextField*/}
                                              {/*                  name={`${row.categoryId}_${pageNumber.id}_pages`}*/}
                                              {/*                  variant="outlined"*/}
                                              {/*                  id={`${row.categoryId}_${pageNumber.id}_pages`}*/}
                                              {/*                  size="small"*/}
                                              {/*                  type="text"*/}

                                              {/*                  onChange={(e) =>*/}
                                              {/*                    this.handleTextFieldChange(categoryIndex, 0, pagesIndex, 'pageNumber', e.target.value)*/}
                                              {/*                  }*/}
                                              {/*              /> *!/*/}
                                              {/*                </TableCell>*/}

                                              {/*            ))*/}

                                              {/*          })}*/}
                                              {/*        </TableRow>*/}
                                              {/*      </TableBody>*/}
                                              {/*    </Table>*/}
                                              {/*  </TableCell>*/}
                                              {/*</TableRow>*/}
                                            </TableBody>
                                          </Table>
                                        </TableCell>
                                      </TableRow>

                                      {/*<TableRow>*/}
                                      {/*  <TableCell align="left">*/}
                                      {/*    <Table style={{border: "1px solid rgb(224 224 224)"}}*/}
                                      {/*           aria-label="simple table">*/}
                                      {/*      <TableHead>*/}
                                      {/*        <TableRow>*/}
                                      {/*          {row.productAttributes[0].pageTypes.map((page) => (*/}

                                      {/*              page.pages.map((pageNumber) => (*/}
                                      {/*                  <TableCell align="left">*/}

                                      {/*                    {pageNumber.userLabel + "(" + page.userLabel + ")"} </TableCell>*/}

                                      {/*              ))*/}

                                      {/*          ))}*/}
                                      {/*        </TableRow>*/}

                                      {/*      </TableHead>*/}
                                      {/*      <TableBody>*/}
                                      {/*        <TableRow>*/}
                                      {/*          {row.productAttributes[0].pageTypes.map((pageType) => {*/}
                                      {/*            const pageTypeId = pageType.id;*/}
                                      {/*            return pageType.pages.map((pageNumber, pagesIndex) => (*/}
                                      {/*                <TableCell align="left">*/}
                                      {/*                  <input type="hidden"*/}
                                      {/*                         name={`${row.categoryId}_${pageTypeId}:pageNumber`}*/}
                                      {/*                         value={pageNumber.id}/>*/}
                                      {/*                  /!* <input type="hidden" id={`${row.categoryId}_${pageNumber.id}_pages`} value={10.0+1}/> *!/*/}

                                      {/*                  <TextFieldInList*/}
                                      {/*                      key={pagesIndex + row.categoryId}*/}
                                      {/*                      id={`${row.categoryId}_${pageNumber.id}_${pageTypeId}_pages`}*/}
                                      {/*                      name={`${row.categoryId}_${pageNumber.id}_${pageTypeId}_pages`}*/}
                                      {/*                      label="price"*/}
                                      {/*                      initialPrice={pageNumber.price}*/}
                                      {/*                  />*/}

                                      {/*                  /!* <TextField*/}
                                      {/*                  name={`${row.categoryId}_${pageNumber.id}_pages`}*/}
                                      {/*                  variant="outlined"*/}
                                      {/*                  id={`${row.categoryId}_${pageNumber.id}_pages`}*/}
                                      {/*                  size="small"*/}
                                      {/*                  type="text"*/}

                                      {/*                  onChange={(e) =>*/}
                                      {/*                    this.handleTextFieldChange(categoryIndex, 0, pagesIndex, 'pageNumber', e.target.value)*/}
                                      {/*                  }*/}
                                      {/*              /> *!/*/}
                                      {/*                </TableCell>*/}

                                      {/*            ))*/}

                                      {/*          })}*/}
                                      {/*        </TableRow>*/}
                                      {/*      </TableBody>*/}
                                      {/*    </Table>*/}
                                      {/*  </TableCell>*/}
                                      {/*</TableRow>*/}

                                      <></>
                                    </TableBody>
                                  </Table>
                                </TableCell>
                              </TableRow>
                              {/* Pages Types Ended */}

                              {/* Covers Started */}
                              {row.categoryId == 1 && (
                                <TableRow>
                                  <TableCell>
                                    <Table
                                      style={{
                                        border: "1px solid rgb(224 224 224)",
                                        borderBottom:
                                          "1px solid rgb(224 224 224)",
                                      }}
                                      aria-label="simple table"
                                    >
                                      <TableHead>
                                        <TableRow
                                          className={classes.tableSubHeaderRow}
                                        >
                                          <TableCell
                                            align="left"
                                            className={
                                              classes.tableSubHeaderCell
                                            }
                                          >
                                            Covers{" "}
                                          </TableCell>
                                        </TableRow>
                                      </TableHead>
                                      <TableBody>
                                        <TableRow>
                                          <TableCell align="left">
                                            <Table
                                              style={{
                                                border:
                                                  "1px solid rgb(224 224 224)",
                                              }}
                                              aria-label="simple table"
                                            >
                                              {row.productAddOns[0].cover.map(
                                                (cover, coverIndex) => {
                                                  return (
                                                    <>
                                                      {coverIndex % 4 === 0 ? (
                                                        <>
                                                          <TableHead>
                                                            <TableRow>
                                                              <TableCell align="left">
                                                                {
                                                                  row
                                                                    .productAddOns[0]
                                                                    .cover[
                                                                    coverIndex
                                                                  ].userLabel
                                                                }{" "}
                                                              </TableCell>
                                                              {coverIndex + 1 <
                                                                row
                                                                  .productAddOns[0]
                                                                  .cover
                                                                  .length ? (
                                                                <TableCell align="left">
                                                                  {
                                                                    row
                                                                      .productAddOns[0]
                                                                      .cover[
                                                                      coverIndex +
                                                                      1
                                                                    ].userLabel
                                                                  }{" "}
                                                                </TableCell>
                                                              ) : (
                                                                <span />
                                                              )}

                                                              {coverIndex + 2 <
                                                                row
                                                                  .productAddOns[0]
                                                                  .cover
                                                                  .length ? (
                                                                <TableCell align="left">
                                                                  {
                                                                    row
                                                                      .productAddOns[0]
                                                                      .cover[
                                                                      coverIndex +
                                                                      2
                                                                    ].userLabel
                                                                  }{" "}
                                                                </TableCell>
                                                              ) : (
                                                                <span />
                                                              )}
                                                              {coverIndex + 3 <
                                                                row
                                                                  .productAddOns[0]
                                                                  .cover
                                                                  .length ? (
                                                                <TableCell align="left">
                                                                  {
                                                                    row
                                                                      .productAddOns[0]
                                                                      .cover[
                                                                      coverIndex +
                                                                      3
                                                                    ].userLabel
                                                                  }{" "}
                                                                </TableCell>
                                                              ) : (
                                                                <span />
                                                              )}
                                                            </TableRow>
                                                          </TableHead>
                                                          <TableBody>
                                                            <TableRow>
                                                              <TableCell align="left">
                                                                <input
                                                                  type="hidden"
                                                                  name={`${row.categoryId}:coverId`}
                                                                  value={
                                                                    cover.productId
                                                                  }
                                                                />
                                                                <TextFieldInList
                                                                  key={
                                                                    coverIndex +
                                                                    row.categoryId
                                                                  }
                                                                  id={`${cover.productId}_product`}
                                                                  name={`${cover.productId}_product`}
                                                                  label="price"
                                                                  initialPrice={
                                                                    cover.price
                                                                  }
                                                                />
                                                              </TableCell>
                                                              {coverIndex + 1 <
                                                                row
                                                                  .productAddOns[0]
                                                                  .cover
                                                                  .length ? (
                                                                <TableCell align="left">
                                                                  <input
                                                                    type="hidden"
                                                                    name={`${row.categoryId}:coverId`}
                                                                    value={
                                                                      row
                                                                        .productAddOns[0]
                                                                        .cover[
                                                                        coverIndex +
                                                                        1
                                                                      ]
                                                                        .productId
                                                                    }
                                                                  />
                                                                  <TextFieldInList
                                                                    key={
                                                                      coverIndex +
                                                                      1 +
                                                                      row.categoryId
                                                                    }
                                                                    id={`${row
                                                                      .productAddOns[0]
                                                                      .cover[
                                                                      coverIndex +
                                                                      1
                                                                    ]
                                                                      .productId
                                                                      }_product`}
                                                                    name={`${row
                                                                      .productAddOns[0]
                                                                      .cover[
                                                                      coverIndex +
                                                                      1
                                                                    ]
                                                                      .productId
                                                                      }_product`}
                                                                    label="price"
                                                                    initialPrice={
                                                                      row
                                                                        .productAddOns[0]
                                                                        .cover[
                                                                        coverIndex +
                                                                        1
                                                                      ].price
                                                                    }
                                                                  />
                                                                </TableCell>
                                                              ) : (
                                                                <span />
                                                              )}

                                                              {coverIndex + 2 <
                                                                row
                                                                  .productAddOns[0]
                                                                  .cover
                                                                  .length ? (
                                                                <TableCell align="left">
                                                                  <input
                                                                    type="hidden"
                                                                    name={`${row.categoryId}:coverId`}
                                                                    value={
                                                                      row
                                                                        .productAddOns[0]
                                                                        .cover[
                                                                        coverIndex +
                                                                        2
                                                                      ]
                                                                        .productId
                                                                    }
                                                                  />
                                                                  <TextFieldInList
                                                                    key={
                                                                      coverIndex +
                                                                      2 +
                                                                      row.categoryId
                                                                    }
                                                                    id={`${row
                                                                      .productAddOns[0]
                                                                      .cover[
                                                                      coverIndex +
                                                                      2
                                                                    ]
                                                                      .productId
                                                                      }_product`}
                                                                    name={`${row
                                                                      .productAddOns[0]
                                                                      .cover[
                                                                      coverIndex +
                                                                      2
                                                                    ]
                                                                      .productId
                                                                      }_product`}
                                                                    label="price"
                                                                    initialPrice={
                                                                      row
                                                                        .productAddOns[0]
                                                                        .cover[
                                                                        coverIndex +
                                                                        2
                                                                      ].price
                                                                    }
                                                                  />
                                                                </TableCell>
                                                              ) : (
                                                                <span />
                                                              )}
                                                              {coverIndex + 3 <
                                                                row
                                                                  .productAddOns[0]
                                                                  .cover
                                                                  .length ? (
                                                                <TableCell align="left">
                                                                  <input
                                                                    type="hidden"
                                                                    name={`${row.categoryId}:coverId`}
                                                                    value={
                                                                      row
                                                                        .productAddOns[0]
                                                                        .cover[
                                                                        coverIndex +
                                                                        3
                                                                      ]
                                                                        .productId
                                                                    }
                                                                  />
                                                                  <TextFieldInList
                                                                    key={
                                                                      coverIndex +
                                                                      3 +
                                                                      row.categoryId
                                                                    }
                                                                    id={`${row
                                                                      .productAddOns[0]
                                                                      .cover[
                                                                      coverIndex +
                                                                      3
                                                                    ]
                                                                      .productId
                                                                      }_product`}
                                                                    name={`${row
                                                                      .productAddOns[0]
                                                                      .cover[
                                                                      coverIndex +
                                                                      3
                                                                    ]
                                                                      .productId
                                                                      }_product`}
                                                                    label="price"
                                                                    initialPrice={
                                                                      row
                                                                        .productAddOns[0]
                                                                        .cover[
                                                                        coverIndex +
                                                                        3
                                                                      ].price
                                                                    }
                                                                  />
                                                                </TableCell>
                                                              ) : (
                                                                <span />
                                                              )}
                                                            </TableRow>
                                                          </TableBody>
                                                        </>
                                                      ) : (
                                                        <span />
                                                      )}
                                                    </>
                                                  );
                                                }
                                              )}
                                            </Table>
                                          </TableCell>
                                        </TableRow>
                                      </TableBody>
                                    </Table>
                                  </TableCell>
                                </TableRow>
                              )}
                              {/* Covers Ended */}

                              {/* Lamination Started */}
                              {(row.categoryId == 1 || row.categoryId == 2) && (
                                <TableRow>
                                  <TableCell>
                                    <Table
                                      style={{
                                        border: "1px solid rgb(224 224 224)",
                                        borderBottom:
                                          "1px solid rgb(224 224 224)",
                                      }}
                                      aria-label="simple table"
                                    >
                                      <TableHead>
                                        <TableRow
                                          className={classes.tableSubHeaderRow}
                                        >
                                          <TableCell
                                            align="left"
                                            className={
                                              classes.tableSubHeaderCell
                                            }
                                          >
                                            Lamination{" "}
                                          </TableCell>
                                        </TableRow>
                                      </TableHead>
                                      <TableBody>
                                        <TableRow>
                                          <TableCell>
                                            <Table
                                              style={{
                                                border:
                                                  "1px solid rgb(224 224 224)",
                                                borderBottom:
                                                  "1px solid rgb(224 224 224)",
                                              }}
                                              aria-label="simple table"
                                            >
                                              {row.productAddOns[0].lamination.map(
                                                (
                                                  lamination,
                                                  laminationIndex
                                                ) => {
                                                  return (
                                                    <>
                                                      {laminationIndex % 4 ===
                                                        0 ? (
                                                        <>
                                                          <TableHead>
                                                            <TableRow>
                                                              <TableCell align="left">
                                                                {
                                                                  row
                                                                    .productAddOns[0]
                                                                    .lamination[
                                                                    laminationIndex
                                                                  ].userLabel
                                                                }{" "}
                                                              </TableCell>
                                                              {laminationIndex +
                                                                1 <
                                                                row
                                                                  .productAddOns[0]
                                                                  .lamination
                                                                  .length ? (
                                                                <TableCell align="left">
                                                                  {
                                                                    row
                                                                      .productAddOns[0]
                                                                      .lamination[
                                                                      laminationIndex +
                                                                      1
                                                                    ].userLabel
                                                                  }{" "}
                                                                </TableCell>
                                                              ) : (
                                                                <span />
                                                              )}

                                                              {laminationIndex +
                                                                2 <
                                                                row
                                                                  .productAddOns[0]
                                                                  .lamination
                                                                  .length ? (
                                                                <TableCell align="left">
                                                                  {
                                                                    row
                                                                      .productAddOns[0]
                                                                      .lamination[
                                                                      laminationIndex +
                                                                      2
                                                                    ].userLabel
                                                                  }{" "}
                                                                </TableCell>
                                                              ) : (
                                                                <span />
                                                              )}
                                                              {laminationIndex +
                                                                3 <
                                                                row
                                                                  .productAddOns[0]
                                                                  .lamination
                                                                  .length ? (
                                                                <TableCell align="left">
                                                                  {
                                                                    row
                                                                      .productAddOns[0]
                                                                      .lamination[
                                                                      laminationIndex +
                                                                      3
                                                                    ].userLabel
                                                                  }{" "}
                                                                </TableCell>
                                                              ) : (
                                                                <span />
                                                              )}
                                                            </TableRow>
                                                          </TableHead>
                                                          <TableBody>
                                                            <TableRow>
                                                              <TableCell align="left">
                                                                <input
                                                                  type="hidden"
                                                                  name={`${row.categoryId}:laminationId`}
                                                                  value={
                                                                    lamination.productId
                                                                  }
                                                                />
                                                                <TextFieldInList
                                                                  key={
                                                                    laminationIndex +
                                                                    row.categoryId
                                                                  }
                                                                  id={`${lamination.productId}_product`}
                                                                  name={`${lamination.productId}_product`}
                                                                  label="price"
                                                                  initialPrice={
                                                                    lamination.price
                                                                  }
                                                                />
                                                              </TableCell>
                                                              {laminationIndex +
                                                                1 <
                                                                row
                                                                  .productAddOns[0]
                                                                  .lamination
                                                                  .length ? (
                                                                <TableCell align="left">
                                                                  <input
                                                                    type="hidden"
                                                                    name={`${row.categoryId}:laminationId`}
                                                                    value={
                                                                      row
                                                                        .productAddOns[0]
                                                                        .lamination[
                                                                        laminationIndex +
                                                                        1
                                                                      ]
                                                                        .productId
                                                                    }
                                                                  />
                                                                  <TextFieldInList
                                                                    key={
                                                                      laminationIndex +
                                                                      1 +
                                                                      row.categoryId
                                                                    }
                                                                    id={`${row
                                                                      .productAddOns[0]
                                                                      .lamination[
                                                                      laminationIndex +
                                                                      1
                                                                    ]
                                                                      .productId
                                                                      }_product`}
                                                                    name={`${row
                                                                      .productAddOns[0]
                                                                      .lamination[
                                                                      laminationIndex +
                                                                      1
                                                                    ]
                                                                      .productId
                                                                      }_product`}
                                                                    label="price"
                                                                    initialPrice={
                                                                      row
                                                                        .productAddOns[0]
                                                                        .lamination[
                                                                        laminationIndex +
                                                                        1
                                                                      ].price
                                                                    }
                                                                  />
                                                                </TableCell>
                                                              ) : (
                                                                <span />
                                                              )}

                                                              {laminationIndex +
                                                                2 <
                                                                row
                                                                  .productAddOns[0]
                                                                  .lamination
                                                                  .length ? (
                                                                <TableCell align="left">
                                                                  <input
                                                                    type="hidden"
                                                                    name={`${row.categoryId}:laminationId`}
                                                                    value={
                                                                      row
                                                                        .productAddOns[0]
                                                                        .lamination[
                                                                        laminationIndex +
                                                                        2
                                                                      ]
                                                                        .productId
                                                                    }
                                                                  />
                                                                  <TextFieldInList
                                                                    key={
                                                                      laminationIndex +
                                                                      2 +
                                                                      row.categoryId
                                                                    }
                                                                    id={`${row
                                                                      .productAddOns[0]
                                                                      .lamination[
                                                                      laminationIndex +
                                                                      2
                                                                    ]
                                                                      .productId
                                                                      }_product`}
                                                                    name={`${row
                                                                      .productAddOns[0]
                                                                      .lamination[
                                                                      laminationIndex +
                                                                      2
                                                                    ]
                                                                      .productId
                                                                      }_product`}
                                                                    label="price"
                                                                    initialPrice={
                                                                      row
                                                                        .productAddOns[0]
                                                                        .lamination[
                                                                        laminationIndex +
                                                                        2
                                                                      ].price
                                                                    }
                                                                  />
                                                                </TableCell>
                                                              ) : (
                                                                <span />
                                                              )}
                                                              {laminationIndex +
                                                                3 <
                                                                row
                                                                  .productAddOns[0]
                                                                  .lamination
                                                                  .length ? (
                                                                <TableCell align="left">
                                                                  <input
                                                                    type="hidden"
                                                                    name={`${row.categoryId}:laminationId`}
                                                                    value={
                                                                      row
                                                                        .productAddOns[0]
                                                                        .lamination[
                                                                        laminationIndex +
                                                                        3
                                                                      ]
                                                                        .productId
                                                                    }
                                                                  />
                                                                  <TextFieldInList
                                                                    key={
                                                                      laminationIndex +
                                                                      3 +
                                                                      row.categoryId
                                                                    }
                                                                    id={`${row
                                                                      .productAddOns[0]
                                                                      .lamination[
                                                                      laminationIndex +
                                                                      3
                                                                    ]
                                                                      .productId
                                                                      }_product`}
                                                                    name={`${row
                                                                      .productAddOns[0]
                                                                      .lamination[
                                                                      laminationIndex +
                                                                      3
                                                                    ]
                                                                      .productId
                                                                      }_product`}
                                                                    label="price"
                                                                    initialPrice={
                                                                      row
                                                                        .productAddOns[0]
                                                                        .lamination[
                                                                        laminationIndex +
                                                                        3
                                                                      ].price
                                                                    }
                                                                  />
                                                                </TableCell>
                                                              ) : (
                                                                <span />
                                                              )}
                                                            </TableRow>
                                                          </TableBody>
                                                        </>
                                                      ) : (
                                                        <span />
                                                      )}
                                                    </>
                                                  );
                                                }
                                              )}
                                            </Table>
                                          </TableCell>
                                        </TableRow>
                                      </TableBody>
                                    </Table>
                                  </TableCell>
                                </TableRow>
                              )}

                              {/* Lamination Ended */}
                            </>
                          ) : (
                            <></>
                          )}
                          {/*Pages Styles for Themed Photobook & Mug Prints Start*/}
                          {row.categoryId == 2 || row.categoryId == 9 ? (
                            <>
                              {/* Pages Types Started */}
                              <TableRow>
                                <TableCell>
                                  <Table
                                    style={{
                                      border: "1px solid rgb(224 224 224)",
                                      borderBottom:
                                        "1px solid rgb(224 224 224)",
                                    }}
                                    aria-label="simple table"
                                  >
                                    <TableHead>
                                      <TableRow
                                        className={classes.tableSubHeaderRow}
                                      >
                                        <TableCell
                                          className={classes.tableSubHeaderCell}
                                          align="left"
                                        >
                                          {row.categoryId == 2
                                            ? "Pages"
                                            : "Styles"}{" "}
                                        </TableCell>
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      <TableRow>
                                        <TableCell align="left">
                                          <Table
                                            style={{
                                              border:
                                                "1px solid rgb(224 224 224)",
                                            }}
                                            aria-label="simple table"
                                          >
                                            {row.productAttributes[0].styles.map(
                                              (styles, pageTypesIndex) => {
                                                return (
                                                  <>
                                                    {pageTypesIndex % 4 ===
                                                      0 ? (
                                                      <>
                                                        <TableHead>
                                                          <TableRow>
                                                            <TableCell align="left">
                                                              {
                                                                row
                                                                  .productAttributes[0]
                                                                  .styles[
                                                                  pageTypesIndex
                                                                ].userLabel
                                                              }{" "}
                                                            </TableCell>
                                                            {pageTypesIndex +
                                                              1 <
                                                              row
                                                                .productAttributes[0]
                                                                .styles.length ? (
                                                              <TableCell align="left">
                                                                {
                                                                  row
                                                                    .productAttributes[0]
                                                                    .styles[
                                                                    pageTypesIndex +
                                                                    1
                                                                  ].userLabel
                                                                }{" "}
                                                              </TableCell>
                                                            ) : (
                                                              <span />
                                                            )}

                                                            {pageTypesIndex +
                                                              2 <
                                                              row
                                                                .productAttributes[0]
                                                                .styles.length ? (
                                                              <TableCell align="left">
                                                                {
                                                                  row
                                                                    .productAttributes[0]
                                                                    .styles[
                                                                    pageTypesIndex +
                                                                    2
                                                                  ].userLabel
                                                                }{" "}
                                                              </TableCell>
                                                            ) : (
                                                              <span />
                                                            )}
                                                            {pageTypesIndex +
                                                              3 <
                                                              row
                                                                .productAttributes[0]
                                                                .styles.length ? (
                                                              <TableCell align="left">
                                                                {
                                                                  row
                                                                    .productAttributes[0]
                                                                    .styles[
                                                                    pageTypesIndex +
                                                                    3
                                                                  ].userLabel
                                                                }{" "}
                                                              </TableCell>
                                                            ) : (
                                                              <span />
                                                            )}
                                                          </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                          <TableRow>
                                                            <TableCell align="left">
                                                              <input
                                                                type="hidden"
                                                                name={`${row.categoryId}:productStyleId`}
                                                                value={
                                                                  styles.productId
                                                                }
                                                              />
                                                              <TextFieldInList
                                                                key={
                                                                  pageTypesIndex +
                                                                  row.categoryId
                                                                }
                                                                id={`${styles.productId}_product`}
                                                                name={`${styles.productId}_product`}
                                                                label="price"
                                                                initialPrice={
                                                                  styles.price
                                                                }
                                                              />
                                                            </TableCell>
                                                            {pageTypesIndex +
                                                              1 <
                                                              row
                                                                .productAttributes[0]
                                                                .styles.length ? (
                                                              <TableCell align="left">
                                                                <input
                                                                  type="hidden"
                                                                  name={`${row.categoryId}:productStyleId`}
                                                                  value={
                                                                    row
                                                                      .productAttributes[0]
                                                                      .styles[
                                                                      pageTypesIndex +
                                                                      1
                                                                    ].productId
                                                                  }
                                                                />
                                                                <TextFieldInList
                                                                  key={
                                                                    pageTypesIndex +
                                                                    1 +
                                                                    row.categoryId
                                                                  }
                                                                  id={`${row
                                                                    .productAttributes[0]
                                                                    .styles[
                                                                    pageTypesIndex +
                                                                    1
                                                                  ].productId
                                                                    }_product`}
                                                                  name={`${row
                                                                    .productAttributes[0]
                                                                    .styles[
                                                                    pageTypesIndex +
                                                                    1
                                                                  ].productId
                                                                    }_product`}
                                                                  label="price"
                                                                  initialPrice={
                                                                    row
                                                                      .productAttributes[0]
                                                                      .styles[
                                                                      pageTypesIndex +
                                                                      1
                                                                    ].price
                                                                  }
                                                                />
                                                              </TableCell>
                                                            ) : (
                                                              <span />
                                                            )}

                                                            {pageTypesIndex +
                                                              2 <
                                                              row
                                                                .productAttributes[0]
                                                                .styles.length ? (
                                                              <TableCell align="left">
                                                                <input
                                                                  type="hidden"
                                                                  name={`${row.categoryId}:productStyleId`}
                                                                  value={
                                                                    row
                                                                      .productAttributes[0]
                                                                      .styles[
                                                                      pageTypesIndex +
                                                                      2
                                                                    ].productId
                                                                  }
                                                                />
                                                                <TextFieldInList
                                                                  key={
                                                                    pageTypesIndex +
                                                                    2 +
                                                                    row.categoryId
                                                                  }
                                                                  id={`${row
                                                                    .productAttributes[0]
                                                                    .styles[
                                                                    pageTypesIndex +
                                                                    2
                                                                  ].productId
                                                                    }_product`}
                                                                  name={`${row
                                                                    .productAttributes[0]
                                                                    .styles[
                                                                    pageTypesIndex +
                                                                    2
                                                                  ].productId
                                                                    }_product`}
                                                                  label="price"
                                                                  initialPrice={
                                                                    row
                                                                      .productAttributes[0]
                                                                      .styles[
                                                                      pageTypesIndex +
                                                                      2
                                                                    ].price
                                                                  }
                                                                />
                                                              </TableCell>
                                                            ) : (
                                                              <span />
                                                            )}
                                                            {pageTypesIndex +
                                                              3 <
                                                              row
                                                                .productAttributes[0]
                                                                .styles.length ? (
                                                              <TableCell align="left">
                                                                <input
                                                                  type="hidden"
                                                                  name={`${row.categoryId}:productStyleId`}
                                                                  value={
                                                                    row
                                                                      .productAttributes[0]
                                                                      .styles[
                                                                      pageTypesIndex +
                                                                      3
                                                                    ].productId
                                                                  }
                                                                />
                                                                <TextFieldInList
                                                                  key={
                                                                    pageTypesIndex +
                                                                    3 +
                                                                    row.categoryId
                                                                  }
                                                                  id={`${row
                                                                    .productAttributes[0]
                                                                    .styles[
                                                                    pageTypesIndex +
                                                                    3
                                                                  ].productId
                                                                    }_product`}
                                                                  name={`${row
                                                                    .productAttributes[0]
                                                                    .styles[
                                                                    pageTypesIndex +
                                                                    3
                                                                  ].productId
                                                                    }_product`}
                                                                  label="price"
                                                                  initialPrice={
                                                                    row
                                                                      .productAttributes[0]
                                                                      .styles[
                                                                      pageTypesIndex +
                                                                      3
                                                                    ].price
                                                                  }
                                                                />
                                                              </TableCell>
                                                            ) : (
                                                              <span />
                                                            )}
                                                          </TableRow>
                                                        </TableBody>
                                                      </>
                                                    ) : (
                                                      <span />
                                                    )}
                                                  </>
                                                );
                                              }
                                            )}
                                          </Table>
                                        </TableCell>
                                      </TableRow>
                                      {/*<TableRow  >*/}
                                      {/*  <TableCell align="left">*/}
                                      {/*    <Table style={{border:"1px solid rgb(224 224 224)"}} aria-label="simple table">*/}
                                      {/*      /!*<TableHead>*!/*/}
                                      {/*      /!*  <TableRow>*!/*/}
                                      {/*      /!*    {row.productAttributes[0].pageTypes.map((page) => (*!/*/}

                                      {/*      /!*        page.pages.map((pageNumber) => (*!/*/}
                                      {/*      /!*            <TableCell align="left">*!/*/}

                                      {/*              {pageNumber.userLabel+"("+page.userLabel+")" } </TableCell>*/}

                                      {/*      /!*        ))*!/*/}

                                      {/*    ))}*/}
                                      {/*  </TableRow>*/}

                                      {/*      /!*</TableHead>*!/*/}
                                      {/*      /!*<TableBody>*!/*/}
                                      {/*  <TableRow>*/}
                                      {/*    {row.productAttributes[0].pageTypes.map((pageType) => {*/}
                                      {/*      const pageTypeId=pageType.id;*/}
                                      {/*      return   pageType.pages.map((pageNumber,pagesIndex) => (*/}
                                      {/*          <TableCell align="left">*/}
                                      {/*            <input type="hidden" name={`${row.categoryId}_${pageTypeId}:pageNumber`} value={pageNumber.id}/>*/}
                                      {/*            /!* <input type="hidden" id={`${row.categoryId}_${pageNumber.id}_pages`} value={10.0+1}/> *!/*/}

                                      {/*      /!*            <TextFieldInList*!/*/}
                                      {/*      /!*                key={pagesIndex+row.categoryId}*!/*/}
                                      {/*      /!*                id={`${row.categoryId}_${pageNumber.id}_${pageTypeId}_pages`}*!/*/}
                                      {/*      /!*                name={`${row.categoryId}_${pageNumber.id}_${pageTypeId}_pages`}*!/*/}
                                      {/*      /!*                label="price"*!/*/}
                                      {/*      /!*                initialPrice ={pageNumber.price}*!/*/}
                                      {/*      /!*            />*!/*/}

                                      {/*      /!*            /!* <TextField*!/*/}
                                      {/*      /!*                    name={`${row.categoryId}_${pageNumber.id}_pages`}*!/*/}
                                      {/*      /!*                    variant="outlined"*!/*/}
                                      {/*      /!*                    id={`${row.categoryId}_${pageNumber.id}_pages`}*!/*/}
                                      {/*      /!*                    size="small"*!/*/}
                                      {/*      /!*                    type="text"*!/*/}

                                      {/*      /!*                    onChange={(e) =>*!/*/}
                                      {/*      /!*                      this.handleTextFieldChange(categoryIndex, 0, pagesIndex, 'pageNumber', e.target.value)*!/*/}
                                      {/*      /!*                    }*!/*/}
                                      {/*      /!*                /> *!/*!/*/}
                                      {/*      /!*          </TableCell>*!/*/}

                                      {/*      /!*      ))*!/*/}

                                      {/*      /!*    })}*!/*/}
                                      {/*      /!*  </TableRow>*!/*/}
                                      {/*      /!*</TableBody>*!/*/}
                                      {/*    </Table>*/}
                                      {/*  </TableCell>*/}
                                      {/*</TableRow>*/}
                                      <></>
                                    </TableBody>
                                  </Table>
                                </TableCell>
                              </TableRow>
                              {/*Pages Styles for Themed Photobook & Mug Prints End*/}
                              {/* Pages Types Ended */}

                              {/* Covers Started For Custom Photobook*/}
                              {row.categoryId == 1 && (
                                <TableRow>
                                  <TableCell>
                                    <Table
                                      style={{
                                        border: "1px solid rgb(224 224 224)",
                                        borderBottom:
                                          "1px solid rgb(224 224 224)",
                                      }}
                                      aria-label="simple table"
                                    >
                                      <TableHead>
                                        <TableRow
                                          className={classes.tableSubHeaderRow}
                                        >
                                          <TableCell
                                            align="left"
                                            className={
                                              classes.tableSubHeaderCell
                                            }
                                          >
                                            Covers{" "}
                                          </TableCell>
                                        </TableRow>
                                      </TableHead>
                                      <TableBody>
                                        <TableRow>
                                          <TableCell align="left">
                                            <Table
                                              style={{
                                                border:
                                                  "1px solid rgb(224 224 224)",
                                              }}
                                              aria-label="simple table"
                                            >
                                              <TableHead>
                                                <TableRow>
                                                  {row.productAddOns[0].cover.map(
                                                    (cover) => (
                                                      <TableCell
                                                        key={cover}
                                                        align="left"
                                                      >
                                                        {cover.userLabel}{" "}
                                                      </TableCell>
                                                    )
                                                  )}
                                                </TableRow>
                                              </TableHead>
                                              <TableBody>
                                                <TableRow>
                                                  {row.productAddOns[0].cover.map(
                                                    (cover, coversIndex) => (
                                                      <TableCell
                                                        key={cover}
                                                        align="left"
                                                      >
                                                        <input
                                                          type="hidden"
                                                          name={`${row.categoryId}:coverId`}
                                                          value={cover.id}
                                                        />
                                                        <TextFieldInList
                                                          key={
                                                            coversIndex +
                                                            row.categoryId
                                                          }
                                                          id={`${row.categoryId}_${cover.id}_cover`}
                                                          name={`${row.categoryId}_${cover.id}_cover`}
                                                          label="price"
                                                          initialPrice={
                                                            cover.price
                                                          }
                                                        />
                                                        {/* <TextField
                                                          name={`${row.categoryId}_${cover.id}_cover`}
                                                          variant="outlined"
                                                          id={`${row.categoryId}_${cover.id}_cover`}
                                                          size="small"
                                                          type="text"
                                                          // value={(textFields[categoryIndex] &&
                                                          //         textFields[categoryIndex][0] &&
                                                          //         textFields[categoryIndex][0][packagingIndex] &&
                                                          //         textFields[categoryIndex][0][packagingIndex].packaging) || ''}
                                                      onChange={(e) =>
                                                        this.handleTextFieldChange(categoryIndex, 0, coversIndex, 'cover', e.target.value)
                                                      }
                                                     /> */}
                                                      </TableCell>
                                                    )
                                                  )}
                                                </TableRow>
                                              </TableBody>
                                            </Table>
                                          </TableCell>
                                        </TableRow>
                                      </TableBody>
                                    </Table>
                                  </TableCell>
                                </TableRow>
                              )}
                              {/* Covers Ended */}

                              {/* Lamination Started For Custom Photobook, Themed Photobook */}
                              {row.categoryId == 1 && (
                                <TableRow>
                                  <TableCell>
                                    <Table
                                      style={{
                                        border: "1px solid rgb(224 224 224)",
                                        borderBottom:
                                          "1px solid rgb(224 224 224)",
                                      }}
                                      aria-label="simple table"
                                    >
                                      <TableHead>
                                        <TableRow
                                          className={classes.tableSubHeaderRow}
                                        >
                                          <TableCell
                                            align="left"
                                            className={
                                              classes.tableSubHeaderCell
                                            }
                                          >
                                            Lamination{" "}
                                          </TableCell>
                                        </TableRow>
                                      </TableHead>
                                      <TableBody>
                                        <TableRow>
                                          <TableCell align="left">
                                            <Table
                                              style={{
                                                border:
                                                  "1px solid rgb(224 224 224)",
                                              }}
                                              aria-label="simple table"
                                            >
                                              <TableHead>
                                                <TableRow>
                                                  {row.productAddOns[0].lamination.map(
                                                    (lamination) => (
                                                      <TableCell
                                                        key={lamination}
                                                        align="left"
                                                      >
                                                        {lamination.userLabel}{" "}
                                                      </TableCell>
                                                    )
                                                  )}
                                                </TableRow>
                                              </TableHead>
                                              <TableBody>
                                                <TableRow>
                                                  {row.productAddOns[0].lamination.map(
                                                    (
                                                      lamination,
                                                      laminationIndex
                                                    ) => (
                                                      <TableCell
                                                        key={lamination}
                                                        align="left"
                                                      >
                                                        <input
                                                          type="hidden"
                                                          name={`${row.categoryId}:laminationId`}
                                                          value={lamination.id}
                                                        />

                                                        <TextFieldInList
                                                          key={
                                                            laminationIndex +
                                                            row.categoryId
                                                          }
                                                          id={`${row.categoryId}_${lamination.id}_lamination`}
                                                          name={`${row.categoryId}_${lamination.id}_lamination`}
                                                          label="price"
                                                          initialPrice={
                                                            lamination.price
                                                          }
                                                        />

                                                        {/* <TextField
                                                          name={`${row.categoryId}_${lamination.id}_lamination`}
                                                          variant="outlined"
                                                          id={`${row.categoryId}_${lamination.id}_lamination`}
                                                          size="small"
                                                          type="text"
                                                          // value={(textFields[categoryIndex] &&
                                                          //         textFields[categoryIndex][0] &&
                                                          //         textFields[categoryIndex][0][packagingIndex] &&
                                                          //         textFields[categoryIndex][0][packagingIndex].packaging) || ''}
                                                      onChange={(e) =>
                                                        this.handleTextFieldChange(categoryIndex, 0, laminationIndex, 'lamination', e.target.value)
                                                      }
                                                     /> */}
                                                      </TableCell>
                                                    )
                                                  )}
                                                </TableRow>
                                              </TableBody>
                                            </Table>
                                          </TableCell>
                                        </TableRow>
                                      </TableBody>
                                    </Table>
                                  </TableCell>
                                </TableRow>
                              )}
                              {row.categoryId == 2 && (
                                <TableRow>
                                  <TableCell>
                                    <Table
                                      style={{
                                        border: "1px solid rgb(224 224 224)",
                                        borderBottom:
                                          "1px solid rgb(224 224 224)",
                                      }}
                                      aria-label="simple table"
                                    >
                                      <TableHead>
                                        <TableRow
                                          className={classes.tableSubHeaderRow}
                                        >
                                          <TableCell
                                            align="left"
                                            className={
                                              classes.tableSubHeaderCell
                                            }
                                          >
                                            Lamination{" "}
                                          </TableCell>
                                        </TableRow>
                                      </TableHead>
                                      <TableBody>
                                        <TableRow>
                                          <TableCell align="left">
                                            <Table
                                              style={{
                                                border:
                                                  "1px solid rgb(224 224 224)",
                                              }}
                                              aria-label="simple table"
                                            >
                                              {row.productAddOns[0].lamination.map(
                                                (
                                                  lamination,
                                                  laminationIndex
                                                ) => {
                                                  return (
                                                    <>
                                                      {laminationIndex % 4 ===
                                                        0 ? (
                                                        <>
                                                          <TableHead>
                                                            <TableRow>
                                                              <TableCell align="left">
                                                                {
                                                                  row
                                                                    .productAddOns[0]
                                                                    .lamination[
                                                                    laminationIndex
                                                                  ].userLabel
                                                                }{" "}
                                                              </TableCell>
                                                              {laminationIndex +
                                                                1 <
                                                                row
                                                                  .productAddOns[0]
                                                                  .lamination
                                                                  .length ? (
                                                                <TableCell align="left">
                                                                  {
                                                                    row
                                                                      .productAddOns[0]
                                                                      .lamination[
                                                                      laminationIndex +
                                                                      1
                                                                    ].userLabel
                                                                  }{" "}
                                                                </TableCell>
                                                              ) : (
                                                                <span />
                                                              )}

                                                              {laminationIndex +
                                                                2 <
                                                                row
                                                                  .productAddOns[0]
                                                                  .lamination
                                                                  .length ? (
                                                                <TableCell align="left">
                                                                  {
                                                                    row
                                                                      .productAddOns[0]
                                                                      .lamination[
                                                                      laminationIndex +
                                                                      2
                                                                    ].userLabel
                                                                  }{" "}
                                                                </TableCell>
                                                              ) : (
                                                                <span />
                                                              )}
                                                              {laminationIndex +
                                                                3 <
                                                                row
                                                                  .productAddOns[0]
                                                                  .lamination
                                                                  .length ? (
                                                                <TableCell align="left">
                                                                  {
                                                                    row
                                                                      .productAddOns[0]
                                                                      .lamination[
                                                                      laminationIndex +
                                                                      3
                                                                    ].userLabel
                                                                  }{" "}
                                                                </TableCell>
                                                              ) : (
                                                                <span />
                                                              )}
                                                            </TableRow>
                                                          </TableHead>
                                                          <TableBody>
                                                            <TableRow>
                                                              <TableCell align="left">
                                                                <input
                                                                  type="hidden"
                                                                  name={`${row.categoryId}:laminationId`}
                                                                  value={
                                                                    lamination.productId
                                                                  }
                                                                />
                                                                <TextFieldInList
                                                                  key={
                                                                    laminationIndex +
                                                                    row.categoryId
                                                                  }
                                                                  id={`${lamination.productId}_product`}
                                                                  name={`${lamination.productId}_product`}
                                                                  label="price"
                                                                  initialPrice={
                                                                    lamination.price
                                                                  }
                                                                />
                                                              </TableCell>
                                                              {laminationIndex +
                                                                1 <
                                                                row
                                                                  .productAddOns[0]
                                                                  .lamination
                                                                  .length ? (
                                                                <TableCell align="left">
                                                                  <input
                                                                    type="hidden"
                                                                    name={`${row.categoryId}:laminationId`}
                                                                    value={
                                                                      row
                                                                        .productAddOns[0]
                                                                        .lamination[
                                                                        laminationIndex +
                                                                        1
                                                                      ]
                                                                        .productId
                                                                    }
                                                                  />
                                                                  <TextFieldInList
                                                                    key={
                                                                      laminationIndex +
                                                                      1 +
                                                                      row.categoryId
                                                                    }
                                                                    id={`${row
                                                                      .productAddOns[0]
                                                                      .lamination[
                                                                      laminationIndex +
                                                                      1
                                                                    ]
                                                                      .productId
                                                                      }_product`}
                                                                    name={`${row
                                                                      .productAddOns[0]
                                                                      .lamination[
                                                                      laminationIndex +
                                                                      1
                                                                    ]
                                                                      .productId
                                                                      }_product`}
                                                                    label="price"
                                                                    initialPrice={
                                                                      row
                                                                        .productAddOns[0]
                                                                        .lamination[
                                                                        laminationIndex +
                                                                        1
                                                                      ].price
                                                                    }
                                                                  />
                                                                </TableCell>
                                                              ) : (
                                                                <span />
                                                              )}

                                                              {laminationIndex +
                                                                2 <
                                                                row
                                                                  .productAddOns[0]
                                                                  .lamination
                                                                  .length ? (
                                                                <TableCell align="left">
                                                                  <input
                                                                    type="hidden"
                                                                    name={`${row.categoryId}:laminationId`}
                                                                    value={
                                                                      row
                                                                        .productAddOns[0]
                                                                        .lamination[
                                                                        laminationIndex +
                                                                        2
                                                                      ]
                                                                        .productId
                                                                    }
                                                                  />
                                                                  <TextFieldInList
                                                                    key={
                                                                      laminationIndex +
                                                                      2 +
                                                                      row.categoryId
                                                                    }
                                                                    id={`${row
                                                                      .productAddOns[0]
                                                                      .lamination[
                                                                      laminationIndex +
                                                                      2
                                                                    ]
                                                                      .productId
                                                                      }_product`}
                                                                    name={`${row
                                                                      .productAddOns[0]
                                                                      .lamination[
                                                                      laminationIndex +
                                                                      2
                                                                    ]
                                                                      .productId
                                                                      }_product`}
                                                                    label="price"
                                                                    initialPrice={
                                                                      row
                                                                        .productAddOns[0]
                                                                        .lamination[
                                                                        laminationIndex +
                                                                        2
                                                                      ].price
                                                                    }
                                                                  />
                                                                </TableCell>
                                                              ) : (
                                                                <span />
                                                              )}
                                                              {laminationIndex +
                                                                3 <
                                                                row
                                                                  .productAddOns[0]
                                                                  .lamination
                                                                  .length ? (
                                                                <TableCell align="left">
                                                                  <input
                                                                    type="hidden"
                                                                    name={`${row.categoryId}:laminationId`}
                                                                    value={
                                                                      row
                                                                        .productAddOns[0]
                                                                        .lamination[
                                                                        laminationIndex +
                                                                        3
                                                                      ]
                                                                        .productId
                                                                    }
                                                                  />
                                                                  <TextFieldInList
                                                                    key={
                                                                      laminationIndex +
                                                                      3 +
                                                                      row.categoryId
                                                                    }
                                                                    id={`${row
                                                                      .productAddOns[0]
                                                                      .lamination[
                                                                      laminationIndex +
                                                                      3
                                                                    ]
                                                                      .productId
                                                                      }_product`}
                                                                    name={`${row
                                                                      .productAddOns[0]
                                                                      .lamination[
                                                                      laminationIndex +
                                                                      3
                                                                    ]
                                                                      .productId
                                                                      }_product`}
                                                                    label="price"
                                                                    initialPrice={
                                                                      row
                                                                        .productAddOns[0]
                                                                        .lamination[
                                                                        laminationIndex +
                                                                        3
                                                                      ].price
                                                                    }
                                                                  />
                                                                </TableCell>
                                                              ) : (
                                                                <span />
                                                              )}
                                                            </TableRow>
                                                          </TableBody>
                                                        </>
                                                      ) : (
                                                        <span />
                                                      )}
                                                    </>
                                                  );
                                                }
                                              )}
                                            </Table>
                                          </TableCell>
                                        </TableRow>
                                      </TableBody>
                                    </Table>
                                  </TableCell>
                                </TableRow>
                              )}

                              {/* Lamination Ended */}
                            </>
                          ) : (
                            <></>
                          )}
                          {/*Pages for Themed Photobook End*/}

                          {/* Bundle Started */}
                          {row.categoryId != 1 &&
                            row.categoryId != 2 &&
                            row.categoryId != 6 ? (
                            <TableRow>
                              <TableCell>
                                <Table
                                  style={{
                                    border: "1px solid rgb(224 224 224)",
                                    borderBottom: "1px solid rgb(224 224 224)",
                                  }}
                                  aria-label="simple table"
                                >
                                  <TableHead>
                                    <TableRow
                                      className={classes.tableSubHeaderRow}
                                    >
                                      <TableCell
                                        align="left"
                                        className={classes.tableSubHeaderCell}
                                      >
                                        Bundles{" "}
                                      </TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    <TableRow>
                                      <TableCell align="left">
                                        <Table
                                          style={{
                                            border:
                                              "1px solid rgb(224 224 224)",
                                          }}
                                          aria-label="simple table"
                                        >
                                          {row.productAttributes[0].bundles.map(
                                            (bundle, bundleIndex) => {
                                              return (
                                                <>
                                                  {bundleIndex % 4 === 0 ? (
                                                    <>
                                                      <TableHead>
                                                        <TableRow>
                                                          <TableCell align="left">
                                                            {
                                                              row
                                                                .productAttributes[0]
                                                                .bundles[
                                                                bundleIndex
                                                              ].userLabel
                                                            }{" "}
                                                          </TableCell>
                                                          {bundleIndex + 1 <
                                                            row
                                                              .productAttributes[0]
                                                              .bundles.length ? (
                                                            <TableCell align="left">
                                                              {
                                                                row
                                                                  .productAttributes[0]
                                                                  .bundles[
                                                                  bundleIndex +
                                                                  1
                                                                ].userLabel
                                                              }{" "}
                                                            </TableCell>
                                                          ) : (
                                                            <span />
                                                          )}

                                                          {bundleIndex + 2 <
                                                            row
                                                              .productAttributes[0]
                                                              .bundles.length ? (
                                                            <TableCell align="left">
                                                              {
                                                                row
                                                                  .productAttributes[0]
                                                                  .bundles[
                                                                  bundleIndex +
                                                                  2
                                                                ].userLabel
                                                              }{" "}
                                                            </TableCell>
                                                          ) : (
                                                            <span />
                                                          )}
                                                          {bundleIndex + 3 <
                                                            row
                                                              .productAttributes[0]
                                                              .bundles.length ? (
                                                            <TableCell align="left">
                                                              {
                                                                row
                                                                  .productAttributes[0]
                                                                  .bundles[
                                                                  bundleIndex +
                                                                  3
                                                                ].userLabel
                                                              }{" "}
                                                            </TableCell>
                                                          ) : (
                                                            <span />
                                                          )}
                                                        </TableRow>
                                                      </TableHead>
                                                      <TableBody>
                                                        <TableRow>
                                                          <TableCell align="left">
                                                            <input
                                                              type="hidden"
                                                              name={`${row.categoryId}:bundleId`}
                                                              value={
                                                                bundle.productId
                                                              }
                                                            />
                                                            <TextFieldInList
                                                              // key={bundleIndex+row.categoryId}
                                                              // id={`${row.categoryId}_${bundle.id}_bundle`}
                                                              // name={`${row.categoryId}_${bundle.id}_bundle`}
                                                              // label="price"
                                                              // initialPrice ={bundle.price}
                                                              key={
                                                                bundleIndex +
                                                                row.categoryId
                                                              }
                                                              id={`${bundle.productId}_product`}
                                                              name={`${bundle.productId}_product`}
                                                              label="price"
                                                              initialPrice={
                                                                bundle.price
                                                              }
                                                            />
                                                          </TableCell>
                                                          {bundleIndex + 1 <
                                                            row
                                                              .productAttributes[0]
                                                              .bundles.length ? (
                                                            <TableCell align="left">
                                                              <input
                                                                type="hidden"
                                                                name={`${row.categoryId}:bundleId`}
                                                                value={
                                                                  row
                                                                    .productAttributes[0]
                                                                    .bundles[
                                                                    bundleIndex +
                                                                    1
                                                                  ].productId
                                                                }
                                                              />
                                                              <TextFieldInList
                                                                key={
                                                                  bundleIndex +
                                                                  1 +
                                                                  row.categoryId
                                                                }
                                                                id={`${row
                                                                  .productAttributes[0]
                                                                  .bundles[
                                                                  bundleIndex +
                                                                  1
                                                                ].productId
                                                                  }_product`}
                                                                name={`${row
                                                                  .productAttributes[0]
                                                                  .bundles[
                                                                  bundleIndex +
                                                                  1
                                                                ].productId
                                                                  }_product`}
                                                                label="price"
                                                                initialPrice={
                                                                  row
                                                                    .productAttributes[0]
                                                                    .bundles[
                                                                    bundleIndex +
                                                                    1
                                                                  ].price
                                                                }
                                                              />
                                                            </TableCell>
                                                          ) : (
                                                            <span />
                                                          )}

                                                          {bundleIndex + 2 <
                                                            row
                                                              .productAttributes[0]
                                                              .bundles.length ? (
                                                            <TableCell align="left">
                                                              <input
                                                                type="hidden"
                                                                name={`${row.categoryId}:bundleId`}
                                                                value={
                                                                  row
                                                                    .productAttributes[0]
                                                                    .bundles[
                                                                    bundleIndex +
                                                                    2
                                                                  ].productId
                                                                }
                                                              />
                                                              <TextFieldInList
                                                                key={
                                                                  bundleIndex +
                                                                  2 +
                                                                  row.categoryId
                                                                }
                                                                id={`${row
                                                                  .productAttributes[0]
                                                                  .bundles[
                                                                  bundleIndex +
                                                                  2
                                                                ].productId
                                                                  }_product`}
                                                                name={`${row
                                                                  .productAttributes[0]
                                                                  .bundles[
                                                                  bundleIndex +
                                                                  2
                                                                ].productId
                                                                  }_product`}
                                                                label="price"
                                                                initialPrice={
                                                                  row
                                                                    .productAttributes[0]
                                                                    .bundles[
                                                                    bundleIndex +
                                                                    2
                                                                  ].price
                                                                }
                                                              />
                                                            </TableCell>
                                                          ) : (
                                                            <span />
                                                          )}
                                                          {bundleIndex + 3 <
                                                            row
                                                              .productAttributes[0]
                                                              .bundles.length ? (
                                                            <TableCell align="left">
                                                              <input
                                                                type="hidden"
                                                                name={`${row.categoryId}:bundleId`}
                                                                value={
                                                                  row
                                                                    .productAttributes[0]
                                                                    .bundles[
                                                                    bundleIndex +
                                                                    3
                                                                  ].productId
                                                                }
                                                              />
                                                              <TextFieldInList
                                                                key={
                                                                  bundleIndex +
                                                                  3 +
                                                                  row.categoryId
                                                                }
                                                                id={`${row
                                                                  .productAttributes[0]
                                                                  .bundles[
                                                                  bundleIndex +
                                                                  3
                                                                ].productId
                                                                  }_product`}
                                                                name={`${row
                                                                  .productAttributes[0]
                                                                  .bundles[
                                                                  bundleIndex +
                                                                  3
                                                                ].productId
                                                                  }_product`}
                                                                label="price"
                                                                initialPrice={
                                                                  row
                                                                    .productAttributes[0]
                                                                    .bundles[
                                                                    bundleIndex +
                                                                    3
                                                                  ].price
                                                                }
                                                              />
                                                            </TableCell>
                                                          ) : (
                                                            <span />
                                                          )}
                                                        </TableRow>
                                                      </TableBody>
                                                    </>
                                                  ) : (
                                                    <span />
                                                  )}
                                                </>
                                              );
                                            }
                                          )}
                                        </Table>
                                      </TableCell>
                                    </TableRow>
                                  </TableBody>
                                </Table>
                              </TableCell>
                            </TableRow>
                          ) : (
                            ""
                          )}
                          {/* Bundle Ended */}

                          {/* Packaging Started */}
                          <TableRow>
                            <TableCell>
                              <Table
                                style={{
                                  border: "1px solid rgb(224 224 224)",
                                  borderBottom: "1px solid rgb(224 224 224)",
                                }}
                                aria-label="simple table"
                              >
                                <TableHead>
                                  <TableRow
                                    className={classes.tableSubHeaderRow}
                                  >
                                    <TableCell
                                      align="left"
                                      className={classes.tableSubHeaderCell}
                                    >
                                      Packaging{" "}
                                    </TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  <TableRow>
                                    <TableCell align="left">
                                      <Table
                                        style={{
                                          border: "1px solid rgb(224 224 224)",
                                        }}
                                        aria-label="simple table"
                                      >
                                        {row.productAddOns[0].packaging.map(
                                          (packaging, packagingIndex) => {
                                            return (
                                              <>
                                                {packagingIndex % 4 === 0 ? (
                                                  <>
                                                    <TableHead>
                                                      <TableRow>
                                                        <TableCell align="left">
                                                          {
                                                            row.productAddOns[0]
                                                              .packaging[
                                                              packagingIndex
                                                            ].userLabel
                                                          }{" "}
                                                        </TableCell>
                                                        {packagingIndex + 1 <
                                                          row.productAddOns[0]
                                                            .packaging.length ? (
                                                          <TableCell align="left">
                                                            {
                                                              row
                                                                .productAddOns[0]
                                                                .packaging[
                                                                packagingIndex +
                                                                1
                                                              ].userLabel
                                                            }{" "}
                                                          </TableCell>
                                                        ) : (
                                                          <span />
                                                        )}

                                                        {packagingIndex + 2 <
                                                          row.productAddOns[0]
                                                            .packaging.length ? (
                                                          <TableCell align="left">
                                                            {
                                                              row
                                                                .productAddOns[0]
                                                                .packaging[
                                                                packagingIndex +
                                                                2
                                                              ].userLabel
                                                            }{" "}
                                                          </TableCell>
                                                        ) : (
                                                          <span />
                                                        )}
                                                        {packagingIndex + 3 <
                                                          row.productAddOns[0]
                                                            .packaging.length ? (
                                                          <TableCell align="left">
                                                            {
                                                              row
                                                                .productAddOns[0]
                                                                .packaging[
                                                                packagingIndex +
                                                                3
                                                              ].userLabel
                                                            }{" "}
                                                          </TableCell>
                                                        ) : (
                                                          <span />
                                                        )}
                                                      </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                      <TableRow>
                                                        <TableCell align="left">
                                                          <input
                                                            type="hidden"
                                                            name={`${row.categoryId}:packagingId`}
                                                            value={
                                                              packaging.productId
                                                            }
                                                          />
                                                          <TextFieldInList
                                                            key={
                                                              packagingIndex +
                                                              row.categoryId
                                                            }
                                                            id={`${packaging.productId}_product`}
                                                            name={`${packaging.productId}_product`}
                                                            label="price"
                                                            initialPrice={
                                                              packaging.price
                                                            }
                                                          />
                                                        </TableCell>
                                                        {packagingIndex + 1 <
                                                          row.productAddOns[0]
                                                            .packaging.length ? (
                                                          <TableCell align="left">
                                                            <input
                                                              type="hidden"
                                                              name={`${row.categoryId}:packagingId`}
                                                              value={
                                                                row
                                                                  .productAddOns[0]
                                                                  .packaging[
                                                                  packagingIndex +
                                                                  1
                                                                ].productId
                                                              }
                                                            />
                                                            <TextFieldInList
                                                              key={
                                                                packagingIndex +
                                                                1 +
                                                                row.categoryId
                                                              }
                                                              id={`${row
                                                                .productAddOns[0]
                                                                .packaging[
                                                                packagingIndex +
                                                                1
                                                              ].productId
                                                                }_product`}
                                                              name={`${row
                                                                .productAddOns[0]
                                                                .packaging[
                                                                packagingIndex +
                                                                1
                                                              ].productId
                                                                }_product`}
                                                              label="price"
                                                              initialPrice={
                                                                row
                                                                  .productAddOns[0]
                                                                  .packaging[
                                                                  packagingIndex +
                                                                  1
                                                                ].price
                                                              }
                                                            />
                                                          </TableCell>
                                                        ) : (
                                                          <span />
                                                        )}

                                                        {packagingIndex + 2 <
                                                          row.productAddOns[0]
                                                            .packaging.length ? (
                                                          <TableCell align="left">
                                                            <input
                                                              type="hidden"
                                                              name={`${row.categoryId}:packagingId`}
                                                              value={
                                                                row
                                                                  .productAddOns[0]
                                                                  .packaging[
                                                                  packagingIndex +
                                                                  2
                                                                ].productId
                                                              }
                                                            />
                                                            <TextFieldInList
                                                              key={
                                                                packagingIndex +
                                                                2 +
                                                                row.categoryId
                                                              }
                                                              id={`${row
                                                                .productAddOns[0]
                                                                .packaging[
                                                                packagingIndex +
                                                                2
                                                              ].productId
                                                                }_product`}
                                                              name={`${row
                                                                .productAddOns[0]
                                                                .packaging[
                                                                packagingIndex +
                                                                2
                                                              ].productId
                                                                }_product`}
                                                              label="price"
                                                              initialPrice={
                                                                row
                                                                  .productAddOns[0]
                                                                  .packaging[
                                                                  packagingIndex +
                                                                  2
                                                                ].price
                                                              }
                                                            />
                                                          </TableCell>
                                                        ) : (
                                                          <span />
                                                        )}
                                                        {packagingIndex + 3 <
                                                          row.productAddOns[0]
                                                            .packaging.length ? (
                                                          <TableCell align="left">
                                                            <input
                                                              type="hidden"
                                                              name={`${row.categoryId}:packagingId`}
                                                              value={
                                                                row
                                                                  .productAddOns[0]
                                                                  .packaging[
                                                                  packagingIndex +
                                                                  3
                                                                ].productId
                                                              }
                                                            />
                                                            <TextFieldInList
                                                              key={
                                                                packagingIndex +
                                                                3 +
                                                                row.categoryId
                                                              }
                                                              id={`${row
                                                                .productAddOns[0]
                                                                .packaging[
                                                                packagingIndex +
                                                                3
                                                              ].productId
                                                                }_product`}
                                                              name={`${row
                                                                .productAddOns[0]
                                                                .packaging[
                                                                packagingIndex +
                                                                3
                                                              ].productId
                                                                }_product`}
                                                              label="price"
                                                              initialPrice={
                                                                row
                                                                  .productAddOns[0]
                                                                  .packaging[
                                                                  packagingIndex +
                                                                  3
                                                                ].price
                                                              }
                                                            />
                                                          </TableCell>
                                                        ) : (
                                                          <span />
                                                        )}
                                                      </TableRow>
                                                    </TableBody>
                                                  </>
                                                ) : (
                                                  <span />
                                                )}
                                              </>
                                            );
                                          }
                                        )}

                                        {/*<TableHead>*/}
                                        {/*  <TableRow>*/}
                                        {/*  {row.productAddOns[0].packaging.map((packaging) => (*/}

                                        {/*      <TableCell align="left">{packaging.userLabel} </TableCell>*/}
                                        {/*  ))}*/}

                                        {/*  </TableRow>*/}
                                        {/*</TableHead>*/}
                                        {/*<TableBody>*/}
                                        {/*  <TableRow  >*/}
                                        {/*  {row.productAddOns[0].packaging.map((packaging,packagingIndex) => (*/}

                                        {/*      <TableCell align="left">*/}

                                        {/*        <input type="hidden" name={`${row.categoryId}:packagingId`} value={packaging.id}/>*/}

                                        {/*        <TextFieldInList*/}
                                        {/*                key={packagingIndex+row.categoryId}*/}
                                        {/*                id={`${row.categoryId}_${packaging.id}_packaging`}*/}
                                        {/*                name={`${row.categoryId}_${packaging.id}_packaging`}*/}
                                        {/*                label="price"*/}
                                        {/*                initialPrice ={packaging.price}*/}
                                        {/*          />*/}

                                        {/*        /!* <TextField*/}
                                        {/*          name={`${row.categoryId}_${packaging.id}_packaging`}*/}
                                        {/*          variant="outlined"*/}
                                        {/*          id={`${row.categoryId}_${packaging.id}_packaging`}*/}
                                        {/*          size="small"*/}
                                        {/*          type="text"*/}
                                        {/*          // value={(textFields[categoryIndex] &&*/}
                                        {/*          //         textFields[categoryIndex][0] &&*/}
                                        {/*          //         textFields[categoryIndex][0][packagingIndex] &&*/}
                                        {/*          //         textFields[categoryIndex][0][packagingIndex].packaging) || ''}*/}
                                        {/*      onChange={(e) =>*/}
                                        {/*        this.handleTextFieldChange(categoryIndex, 0, packagingIndex, 'packaging', e.target.value)*/}
                                        {/*      }*/}
                                        {/*      /> *!/*/}

                                        {/*          </TableCell>*/}
                                        {/*  ))}*/}
                                        {/*  </TableRow>*/}
                                        {/*</TableBody>*/}
                                      </Table>
                                    </TableCell>
                                  </TableRow>
                                </TableBody>
                              </Table>
                            </TableCell>
                          </TableRow>
                          {/* Packaging Ended */}
                        </TableBody>
                      </Table>
                    ))}
                  </TableContainer>
                </div>
              )}
            </form>
          </Card>
          <BottomBar
            //rightButtonDisable={this.state.recordId == 0}
            leftButtonAction={() => this.viewReport()}
            leftButtonText="View"
            rightButtonText="Submit"
            rightButtonDisable={this.state.isSubmitLoading}
            rightButtonAction={() => this.submitPrice()}
          />
          <CustomizedSnackbar
            isOpen={this.state.isOpenSnackbar}
            message={this.state.snackbarMessage}
            severity={this.state.snackbarSeverity}
            handleCloseSnackbar={() => this.handleSnackbar(false, "", "")}
            autoHideDuration={3000}
          />
          <Backdrop style={{ zIndex: 1500, color: '#fff' }} open={this.state.isSubmitLoading}>
            <CircularProgress color="inherit" />
          </Backdrop>
        </Grid>
      </Fragment>
    );
  }
}

F303GeneralPricingFormV3.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(useStyles)(F303GeneralPricingFormV3);
